import { en } from "./en";

export const mr: typeof en = {
  nav: {
    home: "मुखपृष्ठ",
    product: "उत्पादन",
    industry: "उद्योग",
    gallery: "दालन",
    contribution: "योगदान",
    dealer: "सेल्स पार्टनर्स",
    team: "टीम",
    about: "आमच्याबद्दल",
    bookNow: "आता बुक करा",
    resources: "संसाधने",
    news: "बातम्या",
    blog: "ब्लॉग",
    evBlog: "ईव्ही ब्लॉग",
    newsDesc: "प्रेस आणि घोषणा",
    blogDesc: "शेतातील कथा",
    evBlogDesc: "इलेक्ट्रिक वाहन अंतर्दृष्टी",
  },
  home: {
    metaTitle: "भारतातील इलेक्ट्रिक ट्रॅक्टर उत्पादक | स्वायत्त इलेक्ट्रिक ट्रॅक्टर्स | AutoNXT",
    // heroBadge: "भारताचा इलेक्ट्रिक ट्रॅक्टर पायनियर",
    heroTitle1: "उद्याच्या",
    heroTitleHighlight: "शेतांना",
    heroTitle2: "शक्ती द्या।",
    heroDesc: "AutoNXT ही भारतातील अग्रगण्य इलेक्ट्रिक ट्रॅक्टर उत्पादक कंपनी आहे, जी कृषी आणि औद्योगिक अनुप्रयोगांसाठी AI-सक्षम इलेक्ट्रिक आणि स्वायत्त ट्रॅक्टर तयार करते. शून्य-उत्सर्जन शेती उपाय, प्रगत बॅटरी तंत्रज्ञान एक्सप्लोर करा आणि आजच डेमो बुक करा।",
    heroAutomation: {
      titlePart1: "भारताचा ",
      titleHighlight: "इलेक्ट्रिक आणि स्वायत्त ट्रॅक्टर उत्पादक",
      subtitle:
        "इंधनावरील खर्च कमी करणारे, देखभाल खर्च वाचवणारे आणि शून्य थेट उत्सर्जनासह उच्च झटपट टॉर्क देणारे इलेक्ट्रिक ट्रॅक्टर शोधा।",
      featureCards: [
        { title: "स्मार्ट तंत्रज्ञान", desc: "जास्तीत जास्त कार्यक्षमतेसाठी AI-चालित सिस्टम." },
        { title: "उच्च कार्यक्षमता", desc: "शक्ती, अचूकता आणि उत्पादकतेसाठी तयार." },
        { title: "विश्वसनीय आणि टिकाऊ", desc: "प्रत्येक प्रकारच्या जमिनी आणि परिस्थितीसाठी मजबूत." },
        { title: "शाश्वत भविष्य", desc: "चांगल्या उद्यासाठी पर्यावरणपूरक उपाय." },
      ],
      taglineBold: "नवकल्पना करा. स्वयंचलित करा. उंच झेप घ्या.",
      taglineNormal: "भविष्य हे बुद्धिमान आहे. भविष्य स्वयंचलित आहे.",
      bottomFeatures: [
        { title: "AI आणि स्वयंचलन", desc: "स्मार्ट ऑपरेशन्ससाठी बुद्धिमान नियंत्रण." },
        { title: "अचूकता आणि नियंत्रण", desc: "अचूक कार्यक्षमतेसाठी प्रगत तंत्रज्ञान." },
        { title: "कमाल कार्यक्षमता", desc: "उत्पादकता वाढवा आणि डाउनटाइम कमी करा." },
        { title: "भविष्यासाठी सज्ज", desc: "उद्याच्या जगासाठी नवीनतम तंत्रज्ञान." },
      ],
    },
    heroDescs: [
      {
        titlePart1: "जड उद्योगांसाठी",
        titleHighlight: "स्मार्ट सोल्यूशन्स",
        normalText: "आमच्या अत्याधुनिक ऑटोमेशन सिस्टमसह तुमच्या औद्योगिक ऑपरेशन्समध्ये बदल घडवून आणा. बांधकामापासून ते उत्पादनापर्यंत, आम्ही बुद्धिमान सोल्यूशन्स देतो."
      },
      {
        titlePart1: "उद्यासाठी",
        titleHighlight: "हरित तंत्रज्ञान",
        normalText: "आमच्या पर्यावरणपूरक तंत्रज्ञान सोल्यूशन्ससह हरित क्रांतीमध्ये सामील व्हा. चांगल्या जगासाठी स्वच्छ ऊर्जा, स्मार्ट सिस्टम आणि शाश्वत पद्धती."
      },
      {
        titlePart1: "आधुनिक शेतीसाठी",
        titleHighlight: "इलेक्ट्रिक ट्रॅक्टर",
        normalText: "आमच्या प्रगत इलेक्ट्रिक ट्रॅक्टरसह शून्य-उत्सर्जन शेतीचा अनुभव घ्या. शेतीच्य भविष्यासाठी शाश्वत, शक्तिशाली आणि बुद्धिमान सोल्यूशन्स."
      }
    ],
    exploreProducts: "उत्पादने पाहा",
    bookNow: "आता बुक करा",
    statsTitle: "भारतातील सर्वोत्तमांचा विश्वास",
    videosTitle: "X45H2 ला कामावर पाहा।",
    videosDesc: "आमच्या YouTube चॅनेलवरून थेट वास्तविक व्हिडिओ — पूरग्रस्त भातशेतीपासून औद्योगिक वाहतुकीपर्यंत।",
    viewChannel: "चॅनेल पाहा",
    viewGallery: "संपूर्ण दालन पाहा",
    fieldBannerTag: "शेतात",
    fieldBannerTitle: "सूर्योदयापासून सूर्यास्तापर्यंत।",
    fieldBannerDesc: "एक charge। सारा दिवस। प्रत्येक हंगाम। ऑटोनेक्स्ट भारतीय शेतीच्या लयीसाठी बनवले आहे।",
    fieldBannerImage: "/sun.webp",
    faqTitle: "वारंवार विचारले जाणारे प्रश्न",
    ctaTitle: "इलेक्ट्रिक होण्यास तयार आहात?",
    ctaDesc: "शून्य उत्सर्जनासह आपल्या कार्यांना शक्ती द्या. शेतांपासून कारखान्यांपर्यंत, ऑटोनेक्स्ट सर्वत्र आहे.",
    ourStory: "आमची कथा",
    faqSub: "प्रश्न आहे? उत्तर शोधा।",
    faqDesc: "आमच्या इलेक्ट्रिक ट्रॅक्टरबद्दल वारंवार विचारले जाणारे प्रश्न।",
    faqCategories: {
      all: "सर्व",
      technical: "तांत्रिक तपशील",
      charging: "चार्जिंग आणि बॅटरी",
      apps: "वापर आणि योग्यता",
      cost: "किंमत आणि कर्ज सुविधा",
      perf: "कार्यक्षमता आणि उत्पादकता",
    },
    faqs: [
      {
        q: "इलेक्ट्रिक ट्रॅक्टर म्हणजे काय?",
        a: "इलेक्ट्रिक ट्रॅक्टर हे बॅटरीवर चालणारे शेतीचे वाहन आहे जे पारंपारिक डिझेल इंजिनऐवजी इलेक्ट्रिक motorsचा वापर करते. हे शून्य थेट उत्सर्जन, झटपट टॉर्क आणि रिचार्ज करण्यायोग्य बॅटरीमध्ये साठवलेली स्वच्छ ऊर्जा प्रदान करते."
      },
      {
        q: "इलेक्ट्रिक ट्रॅक्टरची किंमत किती असते?",
        a: "किंमत मॉडेल कॉन्फिगरेशन, बॅटरी क्षमता आणि सरकारी अनुदानांवर (जसे की FAME-III) अवलंबून असते. सुरुवातीची खरेदी किंमत पारंपारिक ट्रॅक्टरसारखीच असली, तरी याचा चालू खर्च ८०% पर्यंत कमी असल्याने जलद परतावा मिळतो."
      },
      {
        q: "इलेक्ट्रिक ट्रॅक्टर शेतीची जड कामे करू शकतात का?",
        a: "होय. इलेक्ट्रिक मोटर्स ० RPM वरूनच थेट पूर्ण टॉर्क देतात, ज्यामुळे त्यांना उत्कृष्ट नांगरणी आणि वाहतूक क्षमता मिळते. आमचे X45H2 मॉडेल जड वाहतूक (१० टनांपर्यंत) हाताळते आणि सर्व शेतीची अवजारे सहज चालवते."
      },
      {
        q: "इलेक्ट्रिक ट्रॅक्टरची बॅटरी किती काळ टिकते?",
        a: "ऑटोनेक्स्ट ट्रॅक्टर प्रगत लिथियम आयरन फॉस्फेट (LFP) बॅटरी वापरतात ज्या १५००+ चार्ज सायकल्ससाठी डिझाइन केलेल्या आहेत, ज्या ६ ते ८ वर्षांचे सेवा आयुष्य देतात. बॅटरी पॅकवर ६ वर्षांची वॉरंटी मिळते."
      },
      {
        q: "इलेक्ट्रिक ट्रॅक्टर डिझेलपेक्षा स्वस्त आहे का?",
        a: "होय, नक्कीच. डिझेल ट्रॅक्टर चालवण्यासाठी ताशी ₹२५०–४०० खर्च येतो, तर ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टरला ताशी फक्त ₹१२–४४ ची वीज लागते. वर्षाला डिझेल आणि देखभालीचा खर्च सुमारे ₹१.५ ते ₹२.५ लाखांनी कमी होतो."
      },
      {
        q: "भारतीय शेतांसाठी कोणता इलेक्ट्रिक ट्रॅक्टर सर्वोत्तम आहे?",
        a: "हे शेताच्या आकारावर अवलंबून आहे: जड कामासाठी आणि औद्योगिक उपयोगासाठी H55C2 (५५HP) सर्वोत्तम आहे; मध्यम-ते-जड व्यावसायिक शेतीसाठी X45C2 (४५HP) आदर्श आहे; आणि मुख्य X45H2 (४५HP) जड नांगरणी आणि औद्योगिक वाहतुकीसाठी बनवले गेले आहे।"
      }
    ],
    techTag: "मालकीचे तंत्रज्ञान",
    techHeading: "सुरुवातीपासून निर्मित।",
    techTabs: [
      {
        label: "मोटर",
        title: "32 kW इलेक्ट्रिक मोटर",
        subtitle: "उच्च कार्यक्षमता ड्राइव्ह प्रणाली",
        desc: "X45H2 एक उच्च कार्यक्षम ३२ kW इलेक्ट्रिक मोटरद्वारे चालवला जातो जो जास्तीत जास्त टॉर्क आणि अचूकतेसाठी डिझाइन केला आहे। हे गुळगुळीत आणि शक्तिशाली कार्यप्रदर्शन सुनिश्चित करते, ज्यामुळे ते जड शेतीच्या कामांसाठी आदर्श बनते।",
        specs: [
          { label: "पॉवर आउटपुट", value: "32 kW" },
          { label: "मॅक्स टॉर्क", value: "मॅक्स टॉर्क" },
          { label: "अचूकता", value: "अचूकता" },
          { label: "जड कामे", value: "जड कामे" },
        ],
      },
      {
        label: "बॅटरी",
        title: "38.4 kWh बॅटरी पॅक",
        subtitle: "उच्च क्षमता ऊर्जा प्रणाली",
        desc: "३८.४ kWh उच्च क्षमतेच्या बॅटरीने सुसज्ज, X45H2 सलग ८ तास चालतो। जलद चार्जिंग आणि दीर्घ आयुष्यासाठी ऑप्टिमाइझ केलेले, जे शेतात विश्वासार्हता सुनिश्चित करते।",
        specs: [
          { label: "क्षमता", value: "38.4 kWh" },
          { label: "रनटाइम", value: "८ तास" },
          { label: "चार्जिंग", value: "फास्ट चार्ज" },
          { label: "दीर्घायुष्य", value: "दीर्घायुष्य" },
        ],
      },
    ],
    softwareTag: "डिजिटल परिसंस्था",
    softwareHeading: "इलेक्ट्रिक ट्रॅक्टरसाठी फ्लीट मॅनेजमेंट सॉफ्टवेअर",
    softwareDesc: "आपल्या ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर ताफ्याचे व्यवस्थापन, देखरेख आणि देखभाल करण्यासाठी संपूर्ण डिजिटल साधने।",
    softwareTabs: [
      {
        label: "वेब ॲप",
        subtitle: "वेब प्लॅटफॉर्म",
        title: "NXT-फ्लीट डॅशबोर्ड",
        desc: "एक शक्तिशाली ब्राउझर-आधारित ताफा (फ्लीट) व्यवस्थापन प्लॅटफॉर्म। प्रत्येक ट्रॅक्टरवर रिअल टाइममध्ये देखरेख ठेवा, बॅटरीच्या आरोग्याचा मागोवा घ्या आणि एकाच डॅशबोर्डवरून अनेक शेतांचे व्यवस्थापन करा।",
        features: ["रिअल-टाइम जीपीएस ताफा ट्रॅकिंग", "बॅटरी आणि निदान देखरेख", "ताफा विश्लेषण आणि कार्यप्रदर्शन अहवाल", "मल्टी-फार्म व्यवस्थापन पोर्टल"],
        cta: "प्रवेशाची विनंती करा",
      },
      {
        label: "मोबाईल ॲप",
        subtitle: "आयओएस आणि अँड्रॉइड",
        title: "ऑटोनेक्स्ट सर्व्हिस ॲप",
        desc: "सर्व्हिस बुक करा, तंत्रज्ञांचा थेट मागोवा घ्या आणि आपल्या ट्रॅक्टरचा संपूर्ण सेवा इतिहास व्यवस्थापित करा — सर्व काही आपल्या फोनवरून। आयओएस आणि अँड्रॉइडवर उपलब्ध।",
        features: ["सर्व्हिस अपॉइंटमेंट्स बुक आणि शेड्यूल करा", "लाइव्ह तंत्रज्ञ स्थान ट्रॅकिंग", "संपूर्ण सेवा इतिहास आणि रेकॉर्ड", "स्पेअर पार्ट्स ऑर्डरिंग आणि डिलिव्हरी"],
        cta: "ॲप डाउनलोड करा",
      },
      {
        label: "टॅबलेट",
        subtitle: "विश्लेषण डॅशबोर्ड",
        title: "NXT-फ्लीट ॲनालिटिक्स",
        desc: "टॅबलेट-ऑप्टिमाइझ केलेल्या इंटरफेसवर सखोल ताफा विश्लेषण। शेतात किंवा कार्यालयात — आपल्या संपूर्ण ताफ्यातील कार्यक्षमतेचा कल, बॅटरी सायकल आणि परिचालन कार्यक्षमता ट्रॅक करा।",
        features: ["ताफा-व्यापी कार्यप्रदर्शन विश्लेषण", "बॅटरीचे आरोग्य आणि सायकल ट्रॅकिंग", "परिचालन कार्यक्षमता अहवाल", "बहु-वापरकर्ता प्रवेश नियंत्रण"],
        cta: "प्रवेशाची विनंती करा",
      },
    ],
    stats: [
      { label: "नोंदवलेली ऑर्डर्स", value: "270+", sub: "विविध उद्योगांमध्ये ट्रॅक्टर वितरित" },
      { label: "संतुष्ट उद्योग", value: "8", sub: "आमच्या उपायांवर विश्वास ठेवणारे उद्योग" },
      { label: "वाचवलेली झाडे", value: "70,650+", sub: "सर्व ट्रॅक्टर्समध्ये जागतिक CO₂ उत्सर्जन घट" },
      { label: "वाचवलेला खर्च", value: "₹30Cr", sub: "परिचालन खर्चात कपात" },
    ],
    trustedBy: "भारतातील अग्रगण्य संस्थांद्वारे विश्वसनीय",
    partners: [
      "बीएआईएफ विकास संशोधन",
      "डीकेएसएम",
      "नोएडा आंतरराष्ट्रीय विमानतळ",
      "जयवंत शुगर्स लिमिटेड",
      "रिलायन्स न्यू एनर्जी",
      "थर्मॅक्स",
    ],
    lineupTag: "आमची श्रेणी",
    lineupTitle: "प्रत्येक शेत आणि उद्योगासाठी इलेक्ट्रिक ट्रॅक्टर",
    viewAllModels: "सर्व मॉडेल्स पाहा",
    viewDetails: "तपशील पाहा",
    products: [
      {
        name: "ऑटोनेक्स्ट X45H2",
        type: "45HP इलेक्ट्रिक ट्रॅक्टर",
        tag: "बेस्ट सेलर",
        desc: "सर्व शेती आणि वाहतूक कामांमध्ये अष्टपैलुत्व आणि शक्ती। एआय लोड व्यवस्थापन, सौर-सुसंगत।",
        specs: [
          { label: "मोटर", value: "32 kW" },
          { label: "बॅटरी", value: "38.4 kWh" },
          { label: "रेंज", value: "50 किमी" },
        ],
      },
      {
        name: "ऑटोनेक्स्ट X45C2",
        type: "45HP इलेक्ट्रिक ट्रॅक्टर",
        tag: "उच्च कार्यक्षमता",
        desc: "शून्य उत्सर्जनासह 45HP जड कार्यप्रदर्शन — उच्च कार्यक्षमता आणि दीर्घ बॅटरीचे आयुष्य।",
        specs: [
          { label: "मोटर", value: "32 kW" },
          { label: "बॅटरी", value: "38.4 kWh" },
          { label: "रेंज", value: "60 किमी" },
        ],
      },
      {
        name: "ऑटोनेक्स्ट H55C2",
        type: "55HP इलेक्ट्रिक ट्रॅक्टर",
        tag: "उच्च कामगिरी",
        desc: "63.89 kwh लिक्विड-कूल्ड LFP बॅटरी, Carraro ट्रान्समिशन आणि 80 किमी रेंजसह उच्च-कामगिरी असलेला 55HP इलेक्ट्रिक ट्रॅक्टर.",
        specs: [
          { label: "मोटर", value: "45 kW" },
          { label: "बॅटरी", value: "63.89 kwh" },
          { label: "रेंज", value: "80 किमी" },
        ],
      },
    ],
    precisionTag: "तंत्रज्ञान",
    precisionTitle: "प्रगत इलेक्ट्रिक ट्रॅक्टर तंत्रज्ञान",
    precisionDesc: "भारतीय शेतीच्या परिस्थितीमध्ये जास्तीत जास्त कार्यक्षमता, सुरक्षितता आणि कामगिरीसाठी प्रत्येक घटक इंजिनिअर केला आहे।",
    featureImage: "/images/precision/image-mr.webp",
    featureImageAlt: "अचूक अभियांत्रिकी",
    industryTag: "औद्योगिक उपाय",
    industryHeading: "कृषी आणि औद्योगिक अनुप्रयोगांसाठी इलेक्ट्रिक ट्रॅक्टर",
    industryDesc: "ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर भारतातील सर्वात कठीण औद्योगिक वातावरणात सततच्या कामासाठी बनवले आहेत।",
    exploreAllIndustries: "सर्व उद्योगांचे अन्वेषण करा",
    videoActionTag: "ऑटोनेक्स्ट कृतीत",
    videoHeading: "X45H2 ला कामावर पाहा।",
    videoSub: "आमच्या YouTube चॅनेलवरून थेट वास्तविक व्हिडिओ — पूरग्रस्त भातशेतीपासून औद्योगिक वाहतुकीपर्यंत।",
    videos: [
      "X45H2 उत्पादन वर्णन (इंग्रजी)",
      "पूरग्रस्त शेतात रोटाव्हेटरने चिखल करणे",
      "पहिली डिलिव्हरी — जयवंत शुगर मिल",
      "45HP इलेक्ट्रिक ट्रॅक्टर फुल पॉवर डेमो",
      "वाहतूक, टिलर, रीपर आणि वॉटर वॉश",
      "X45H2 उत्पादन वर्णन — हिंदीमध्ये",
    ],
    readyToElectric: "इलेक्ट्रिक होण्यास तयार आहात?",
    readyToElectricDesc: "5,000+ भारतीय शेतकऱ्यांमध्ये सामील व्हा जे ऑटोनेक्स्टवर आले आहेत। आजच आपला ट्रॅक्टर बुक करा।",
    liveTag: "लाइव्ह",
    visitingPass: {
      connectTag: "विजिट आणि कनेक्ट",
      titlePre: "एक ",
      titleHighlight: "विजिटिंग पास",
      titlePost: " किंवा ॲप मिळवा",
      showroom: "फॅक्टरी आणि शोरूम",
      bookPass: "व्हिजिटिंग पास बुक करा",
      visitorPass: "व्हिजिटर पास",
      hinjewadi: "हिंजवडी फेज २, पुणे",
      namePlaceholder: "तुमचे पूर्ण नाव",
      generatePass: "व्हिजिटिंग पास जनरेट करा",
      nameLabel: "नाव",
      dateLabel: "दिनांक",
      purposeLabel: "हेतू",
      blankVal: "— — —"
    },
    mobileApp: {
      tag: "मोबाईल ॲप्लिकेशन",
      titlePre: "ऑटोनेक्स्ट ",
      titleHighlight: "तुमच्या फोनवर",
      desc: "सर्व्हिस बुक करा, तुमच्या ट्रॅक्टरचा मागोवा घ्या, ताफ्याचे व्यवस्थापन करा आणि अलर्टसह अद्ययावत राहा — सर्व काही तुमच्या खिशातून।",
      alert: "रिअल-टाइम अलर्ट आणि सूचना",
      gps: "थेट ट्रॅक्टर जीपीएस ट्रॅकिंग",
      history: "सेवा बुकिंग आणि इतिहास",
      appStore: "ॲप स्टोअर",
      googlePlay: "गुगल प्ले",
      downloadOn: "डाउनलोड करा",
      getItOn: "मिळवा",
    },
    whyAutoNXT: {
      title: "शेतकरी इलेक्ट्रिक ट्रॅक्टरकडे का वळत आहेत?",
      bullets: [
        { title: "कमी परिचालन खर्च", desc: "डिझेलऐवजी विजेचा वापर करून इंधनावरील खर्च ८०% पर्यंत वाचवा." },
        { title: "कमी देखभाल", desc: "७०% कमी हलणारे भाग म्हणजे इंजिन ऑईल किंवा फिल्टर बदलण्याची गरज नाही." },
        { title: "शून्य डिझेल अवलंबित्व", desc: "डिझेलच्या वाढत्या दरांपासून तुमच्या शेतीचे रक्षण करा." },
        { title: "शांत कार्य", desc: "कमी आवाज आणि कंपन ड्रायव्हरचा थकवा कमी करतात." },
        { title: "उच्च झटपट टॉर्क", desc: "० RPM पासून मिळणारा उच्च टॉर्क नांगरणी आणि वाहतुकीला अधिक ताकद देतो." }
      ]
    }
  },
  gallery: {
    metaTitle: "AutoNxt इलेक्ट्रिक ट्रॅक्टर्स गॅलरी | फोटो आणि व्हिडिओ",
    metaDescription: "शेती आणि औद्योगिक कामांमध्ये वापरल्या जाणाऱ्या AutoNxt इलेक्ट्रिक ट्रॅक्टर्सची चित्रे आणि व्हिडिओ पाहा.",
    sectionHeading: "गॅलरी कॅटेगरी ब्राउझ करा",
    title: "ऑटोनेक्स्टला",
    titleHighlight: "कृतीत पाहा।",
    desc: "शेत, उद्योग आणि कार्यक्रमांमध्ये ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टरांचे संपूर्ण छायाचित्र दालन पाहा।",
    photos: "छायाचित्रे",
    events: "कार्यक्रम",
    videos: "व्हिडिओ",
    clickToView: "पूर्ण आकार पाहण्यासाठी कोणत्याही छायाचित्रावर क्लिक करा",
    eventBannerTitle: "अधिकृत सरकारी हस्तांतरण समारंभ",
    eventBannerDesc: "29 जून 2025 — ऑटोनेक्स्टने सरकारी अधिकारी आणि माध्यमांच्या उपस्थितीत X45H2 ट्रॅक्टर सोपवले।",
    watchOnYouTube: "YouTube वर पाहा",
    moreOnYouTube: "YouTube वर अधिक",
    viewAllVideos: "YouTube वर सर्व व्हिडिओ पाहा",
    scheduleDemo: "डेमो शेड्यूल करा",
    seeInPerson: "हे प्रत्यक्ष पाहायचे आहे का?",
    seeInPersonDesc: "आपल्या शेतावर किंवा आमच्या जवळच्या अनुभव केंद्रावर थेट डेमो शेड्यूल करा।",
    galleryBadge: "ऑटोनेक्स्ट दालन",
    youtubeTag: "YouTube",
    youtubeDesc: "उत्पादन व्हिडिओ, फार्म डेमो, उद्योग वापर आणि कंपनी अपडेट्ससाठी ऑटोनेक्स्ट YouTube चॅनेल सबस्क्राईब करा.",
  },
  about: {
    metaTitle: "AutoNxt बद्दल | इलेक्ट्रिक ट्रॅक्टर आणि ऑटोमेशनचे प्रणेते",
    metaDescription: "AutoNxt बद्दल जाणून घ्या. आमचे ध्येय, संस्थापक, कार्यसंघ आणि अत्याधुनिक स्वायत्त तंत्रज्ञान पाहा.",
    tag: "ऑटोनेक्स्टबद्दल",
    heroTitle: "आम्हाला विश्वास आहे की तंत्रज्ञान",
    heroHighlight: "क्रांती",
    heroTitle2: "आणू शकते ज्या प्रकारे आम्ही शेती करतो।",
    heroDesc: "आम्ही अभियंत्यांच्या एका छोट्या संघाने सुरुवात केली जे समाजावर मोठा, दीर्घकाळ टिकणारा प्रभाव असलेल्या कल्पनांवर काम करण्यास उत्सुक होते।",
    missionTag: "आमचे ध्येय",
    missionTitle: "शेतकऱ्यांना सक्षम करणे। आपल्या ग्रहाचे संरक्षण करणे।",
    missionDesc: "शाश्वत, कार्यक्षम आणि शक्तिशाली इलेक्ट्रिक ट्रॅक्टर प्रदान करून शेतीत क्रांती घडवणे।",
    processTag: "आमची अभियांत्रिकी प्रक्रिया",
    processTitle: "सर्वोच्च मानकांनुसार बांधलेले।",
    journeyTag: "आमचा प्रवास",
    journeyTitle: "संकल्पनेपासून बाजार नेत्यापर्यंत।",
    teamTag: "आमची टीम",
    teamTitle: "आमच्या टीमला भेटा",
    teamDesc: "आमचा वैविध्यपूर्ण तज्ञांचा संघ कृषी उद्योगात क्रांती आणण्यासाठी समर्पित आहे।",
    advisorsTag: "आमचे सल्लागार",
    advisorsTitle: "आमच्या दृष्टीकोनाला मार्गदर्शन करणारे उद्योग तज्ञ।",
    ctaTitle: "आमच्या प्रवासाचा भाग व्हायचे आहे का?",
    ctaDesc: "भारतात शाश्वत शेतीचे भविष्य घडवण्यात आमच्यासोबत सामील व्हा।",
    bookDemo: "डेमो बुक करा",
    ourImpact: "आमचा प्रभाव",
    connect: "जोडा",
  },
  chat: {
    welcome: "👋 ऑटोनेक्स्ट एआय मध्ये आपले स्वागत आहे\n\nमैं आपको इलेक्ट्रिक ट्रैक्टर और स्मार्ट खेती के बारे में जानने में मदद करता हूँ।\n\nआप **मराठी**, **हिंदी**, **English**, किंवा **తెలుగు** मध्ये विचारू शकता — जी भाषेत विचारा, त्या भाषेत उत्तर मिळेल।\n\nखाली **Talk with agent** (फोन) किंवा **Schedule meeting** (Zoom) निवडा — किंवा लिहा: \"एजंटशी बोला\", \"मीटिंग शेड्यूल\"।",
    callPromptNow: "ऑटोनेक्स्ट टीमला आताच कॉल करा",
    callPromptScheduled: "कॉल शेड्युल करा",
    meetingOpenMessage: "Zoom वर सेल्स टीमशी भेटण्यासाठी फॉर्म भरा.",
    bookingOpenMessage: "मी तुम्हाला ट्रॅक्टर बुक करण्यात मदत करू शकतो.",
    callSupport: "दूरध्वनी सहाय्य आणि विक्री",
    callDescription: "तुमचा नंबर टाका. आमचे प्रतिनिधी व्यावसायिक वेळेत किंवा तुमच्या सोयीस्कर वेळेत त्वरित कॉल करतील.",
    callTypeSupport: "तांत्रिक सहाय्य",
    callTypeSales: "विक्री आणि डीलरशिप",
    meetingHeading: "ZOOM मीट शेड्युल करा",
    meetingLanguageLabel: "पसंदगीची भाषा:",
    salesMeetingInfo: "मीटिंग उत्पादन तज्ज्ञांसोबत झूम मीटद्वारे घेतल्या जातात (सकाळी १० - संध्याकाळी ५).",
    scheduleMeeting: "मीटिंग शेड्युल निश्चित करा",
    bookingHeader: "ऑटोनेक्स्ट ट्रॅक्टर प्री-बुक करा",
    inputPlaceholder: "काहीही विचारा...",
    clearSession: "सेशन साफ करा",
    talkWithAgent: "एजंटशी बोला",
    assistantSubtitle: "स्मार्ट शेती सहाय्यक",
  },

  common: {
    readMore: "अधिक वाचा",
    learnMore: "अधिक जाणा",
    getInTouch: "संपर्क करा",
    subscribe: "अपडेटसाठी सदस्यता घ्या",
    copyright: "© 2025 ऑटोनेक्स्ट ऑटोमेशन प्रा. लि. सर्व हक्क राखीव।",
    madeIn: "भारतात निर्मित 🇮🇳 भारतीय शेती आणि उद्योगासाठी",
    careers: "करिअर",
    privacyPolicy: "गोपनीयता धोरण",
    termsConditions: "नियम आणि अटी",
    accountDeletion: "खाते हटवणे",
    fleetSolutions: "फ्लीट सोल्यूशन्स",
    batterySystems: "बॅटरी सिस्टम्स",
    motors: "NXT-ड्राइव्ह मोटर्स",
    slogan: "उद्योग, पायाभूत सुविधा आणि शेतीसाठी पुढील पिढीच्या इलेक्ट्रिक मशीन्स तयार करत आहोत.",
    cancel: "रद्द करा",
    loadingModel: "3D मॉडेल लोड होत आहे...",
    dragToRotate: "↺ फिरवण्यासाठी ड्रॅग करा",
    exploreAll: "सर्व पाहा",
    collapseList: "यादी बंद करा",
  },
  book: {
    title: "डेमो बुक करा",
    desc: "ऑटोनेक्स्ट X45H2 इलेक्ट्रिक ट्रॅक्टर प्रत्यक्ष अनुभवा। आपला तपशील भरा आणि आमची टीम संपर्क करेल।",
  },
  news: {
    metaTitle: "AutoNxt बातम्या आणि वृत्त | इलेक्ट्रिक ट्रॅक्टर अपडेट्स",
    metaDescription: "ऑटोनेक्स्ट ऑटोमेशन कडील ताज्या बातम्या, घोषणा आणि मीडिया वृत्तांत पाहा.",
    tag: "बातम्या आणि प्रेस",
    title: "ऑटोनेक्स्ट",
    titleHighlight: "मथळ्यांमध्ये।",
    desc: "ऑटोनेक्स्ट ऑटोमेशनच्या नवीनतम बातम्या, घोषणा आणि माध्यम कव्हरेजसह अद्ययावत राहा।",
    featured: "विशेष कथा",
    allNews: "सर्व बातम्या",
    ctaTitle: "माध्यम चौकशी",
    ctaDesc: "प्रेस किट, मुलाखती आणि भागीदारी घोषणांसाठी ऑटोनेक्स्ट टीमशी संपर्क साधा।",
    contactPress: "प्रेस टीमशी संपर्क करा",
    searchPlaceholder: "बातम्या शोधा...",
    allCategories: "सर्व श्रेणी",
    readArticle: "लेख वाचा",
    noArticlesFound: "कोणतेही लेख सापडले नाही",
    noArticlesDesc: "आपली शोध बदला किंवा दुसरी श्रेणी निवडा।",
    authorLabel: "लेखक",
    pressInquiries: "प्रेस आणि मीडिया चौकशी",
    pressDesc: "प्रेस रिलीज, हाय-रेझ इमेज आणि मीडिया मुलाखतींसाठी, कृपया आमच्या पीआर टीमशी संपर्क साधा.",
    contactPr: "पीआर टीमशी संपर्क साधा",
    liveCovers: "लाइव कव्हरेज",
    pressMedia: "प्रेस आणि माध्यम",
    latestUpdates: "नवीनतम अपडेट्स",
  },
  blog: {
    metaTitle: "फील्ड स्टोरीज आणि फार्मिंग ब्लॉग | AutoNxt इलेक्ट्रिक ट्रॅक्टर्स",
    metaDescription: "इलेक्ट्रिक ट्रॅक्टर्स, शाश्वत शेती आणि भारतातील शेतीच्या भविष्यावर ऑटोनेक्स्ट टीमचे लेख.",
    tag: "ऑटोनेक्स्ट ब्लॉग",
    title: "शेतीच्या भविष्यावर",
    titleHighlight: "अंतर्दृष्टी।",
    desc: "इलेक्ट्रिक ट्रॅक्टर, शाश्वत शेती आणि भारतातील शेतीच्या भविष्यावर ऑटोनेक्स्ट टीमच्या कथा।",
    featured: "विशेष पोस्ट",
    allPosts: "सर्व पोस्ट",
    readFull: "संपूर्ण पोस्ट वाचा",
    writeFor: "ऑटोनेक्स्टसाठी लिहायचे आहे का?",
    writeDesc: "आम्ही शेतकरी, अभियंते आणि कृषी-तंत्र तज्ञांसह मिळून वास्तविक कथा सामायिक करतो।",
    searchPlaceholder: "लेख शोधा...",
    allCategories: "सर्व श्रेणी",
    readArticle: "लेख वाचा",
    noArticlesFound: "कोणतेही लेख सापडले नाही",
    noArticlesDesc: "आपली शोध बदला किंवा दुसरी श्रेणी निवडा।",
    editorsPick: "संपादकाची निवड",
    newBadge: "नवीन",
    readAction: "वाचा",
    authorLabel: "लेखक",
  },
  evBlog: {
    metaTitle: "इलेक्ट्रिक वाहन माहिती आणि तंत्रज्ञान ब्लॉग | AutoNxt",
    metaDescription: "भारतीय आणि जागतिक कृषीतील इलेक्ट्रिक वाहनांवर सखोल तांत्रिक माहिती, बाजार विश्लेषण आणि धोरण आढावा.",
    tag: "ईव्ही ज्ञान केंद्र",
    title: "सर्व काही इलेक्ट्रिक।",
    titleHighlight: "सर्व काही शेती।",
    desc: "भारतीय आणि जागतिक कृषीतील इलेक्ट्रिक वाहनांवर सखोल तांत्रिक माहिती, बाजार विश्लेषण आणि धोरण आढावा।",
    ctaTitle: "ईव्ही बातम्यांशी जोडलेले राहा",
    ctaDesc: "इलेक्ट्रिक शेती, बॅटरी तंत्रज्ञान आणि धोरण अपडेटवरील नवीनतम माहिती आपल्या इनबॉक्समध्ये मिळवा।",
    searchPlaceholder: "लेख शोधा...",
    allCategories: "सर्व श्रेणी",
    readArticle: "लेख वाचा",
    noArticlesFound: "कोणतेही लेख सापडले नाही",
    noArticlesDesc: "आपली शोध बदला किंवा दुसरी श्रेणी निवडा।",
    evRevolution: "ईव्ही क्रांती",
  },
  productPage: {
    metaTitle: "AutoNxt इलेक्ट्रिक ट्रॅक्टर्स श्रेणी | उच्च क्षमतेचे ई-ट्रॅक्टर्स",
    metaDescription: "शेती आणि औद्योगिक वाहतुकीसाठी बनवलेले AutoNxt चे इलेक्ट्रिक ट्रॅक्टर्स पाहा.",
    badge: "इलेक्ट्रिक लाइनअप २०२५",
    title: "इलेक्ट्रिक",
    titleHighlight: "ट्रॅक्टर्स.",
    desc: "शाश्वत, शक्तिशाली आणि कार्यक्षम इलेक्ट्रिक ट्रॅक्टर्ससह शेतीमध्ये क्रांती घडवून आणणे — प्रत्येक शेतासाठी, प्रत्येक भूप्रदेशासाठी तयार केलेले.",
    hpRange: "HP श्रेणी",
    charge: "चार्ज",
    availableNow: "आता उपलब्ध आहे",
    implementLabel: "कृषी उपकरण",
    filterTabs: {
      all: "सर्व उत्पादने",
      tractors: "ट्रॅक्टर्स",
      attachments: "कृषी उपकरणे"
    },
    chargingTime: "3-6 तास",
    modelsCount: "3 ट्रॅक्टर्स",
    viewDetails: "तपशील पाहा",
    book: "बुक",
    viewGallery: "दालन पाहा",
    scheduleTestDrive: "डेमो शेड्यूल करा",
    seeIndustries: "उद्योग पाहा",
    models: "मॉडेल्स",
    flagshipModel: "फ्लॅगशिप मॉडेल",
    zeroEmissions: "शून्य उत्सर्जन",
    electric100: "१००% इलेक्ट्रिक",
    ourProducts: "आमची उत्पादने",
    exploreAll: "संपूर्ण श्रेणी एक्सप्लोर करा",
    exploreDesc: "लहान शेतांसाठी कॉम्पॅक्ट मॉडेल्सपासून ते हेवी-ड्यूटी व्यावसायिक ट्रॅक्टर्सपर्यंत — प्रत्येक कामासाठी योग्य साधने.",
    implementsTitle: "कृषी उपकरणे आणि अटॅचमेंट्स",
    coreTech: "मूळ तंत्रज्ञान",
    builtDifferent: "काहीतरी वेगळे आहे.",
    fieldBannerTag: "जून २०२५ · हस्तांतरण सोहळा",
    fieldBannerTitle: "शेतातील ट्रॅक्टर.",
    readyToPower: "शेतांना वीज देण्यासाठी तयार आहात?",
    experienceTag: "ऑटोनेक्स्टचा अनुभव घ्या",
    features: {
      zeroEmissions: "शून्य उत्सर्जन",
      zeroEmissionsDesc: "१००% इलेक्ट्रिक ड्राइव्हट्रेन",
      instantTorque: "झटपट टॉर्क",
      instantTorqueDesc: "प्रत्येक भूप्रदेशावर शून्य आरपीएमपासून",
      fastCharging: "जलद चार्जिंग",
      fastChargingDesc: "३-४ तासांत पूर्ण चार्ज",
      warranty: "५ वर्षांची वॉरंटी",
      warrantyDesc: "अखिल भारतीय सेवा नेटवर्कचे समर्थन"
    },
    specs: {
      power: "शक्ती",
      battery: "बॅटरी",
      range: "रेंज",
      runtime: "रन टाइम",
      charging: "चार्जिंग",
      lifting: "उचलण्याची क्षमता",
      torque: "कमाल टॉर्क",
    },
    tractorsList: {
      x45h2: {
        badge: "फ्लॅगशिप",
        type: "45HP इलेक्ट्रिक ट्रॅक्टर",
        desc: "आमचा प्रमुख 45HP इलेक्ट्रिक ट्रॅक्टर प्रगत बॅटरी तंत्रज्ञान आणि मोठ्या प्रमाणावर शेती कामांसाठी उत्कृष्ट कामगिरीसह.",
        specs: {
          power: "32 kW",
          battery: "38.4 kWh",
          range: "50 किमी",
          charging: "ऑफ-बोर्ड - DC फास्ट चार्जिंग 60kW - 45 मिनिटे"
        }
      },
      h55c2: {
        badge: "उच्च कामगिरी",
        type: "55HP इलेक्ट्रिक ट्रॅक्टर",
        desc: "45 kW PMSM मोटर, 63.89 kwh LFP लिक्विड-कूल्ड बॅटरी, कॅरारो ट्रान्समिशन, 410 NM टॉर्क आणि 80 किमी रेंजसह मोठ्या प्रमाणावर शेती आणि औद्योगिक कामांसाठी उच्च कार्यक्षमतेचा 55HP इलेक्ट्रिक ट्रॅक्टर.",
        specs: {
          power: "45 kW",
          battery: "63.89 kwh LFP",
          range: "80 किमी",
          charging: "AC फास्ट 13.2 kW / DC फास्ट 40kW ड्यूल गन"
        }
      },
      x45c2: {
        badge: "उच्च कार्यक्षमता",
        type: "45HP वाणिज्यिक इलेक्ट्रिक ट्रॅक्टर",
        desc: "वाटर-कूल्ड PMSM मोटर, 60 km रेंज, स्मार्ट टेलिमॅटिक्स आणि ऑनबोर्ड फास्ट चार्जिंगसह व्यावसायिक शेतीसाठी उच्च कार्यक्षमतेचा 45HP इलेक्ट्रिक ट्रॅक्टर.",
        specs: {
          power: "32 kW",
          battery: "38.4 kWh LFP",
          range: "60 किमी",
          charging: "AC स्लो 6.6 kW / AC फास्ट 13.2 kW"
        }
      }
    },
    implementsList: {
      bucket: {
        badge: "हेवी ड्युटी",
        name: "१८ फूट ग्रॅबर बकेट",
        desc: "कार्यक्षम साहित्य हाताळणी आणि उत्खनन कामांसाठी डिजाइन केलेले हेवी-ड्यूटी 18 फूट ग्रॅबर बकेट अॉती. कठिण बांधकाम आणि शेती वातावरणात जास्तीत जास्त टिकाऊपणा आणि कार्यक्षमतेसाठी उत्कृष्ट साहित्य आणि प्रगत अभियांत्रिकीसह निर्मित."
      },
      catcher: {
        badge: "अचूकता",
        name: "१८ फूट कॅचर",
        desc: "शेती आणि औद्योगिक अनुप्रयोगांत इष्टतम कार्यक्षमतेसाठी प्रगत हायड्रोलिक नियंत्रण आणि टिकाऊ बांधणीसह कार्यक्षम साहित्य संकलन आणि हाताळणीसाठी अचूकपणे अभियांत्रित 18 फूट कॅचर अॉती. कापणी, साहित्य वर्गीकरण आणि विशेष संकलन कार्यांसाठी आदर्श. उत्कृष्ट साहित्य आणि अत्याधुनिक अभियांत्रिकीसह निर्मित."
      },
      loader: {
        badge: "जास्तीत जास्त भार",
        name: "१८ फूट लोडर बकेट",
        desc: "लोडिंग आणि साहित्य वाहतुक कार्यांसाठी कमाल कार्यक्षमतेसाठी अभियांत्रित हेवी-ड्यूटी 18 फूट लोडर बकेट. सर्वात कठिण बांधकाम, खनन आणि शेती कार्यांसाठी उत्कृष्ट शक्ती साहित्य आणि प्रगत हायड्रोलिक प्रणालीसह निर्मित. साहित्य धारण आणि कार्यक्षम लोडिंग चक्रांसाठी अनुकूलित बकेट गणित."
      }
    },
    techSpecsList: {
      battery: {
        title: "LFP बॅटरी पॅक",
        desc: "उच्च घनतेचे लिथियम आयर्न फॉस्फेट सेल्स. २,०००+ charge सायकल्स. दशकाहून अधिक शेती आयुष्यासाठी IP67 वॉटरप्रूफ.",
        stat: "२,०००+",
        statLabel: "चार्ज सायकल्स"
      },
      motor: {
        title: "NXT-ड्राइव्ह मोटर",
        desc: "अक्षीय प्रवाह स्थायी चुंबक मोटर. ९६% सर्वोच्च कार्यक्षमता. झटपट टॉर्क डिलिव्हरी. स्थानिक सेवेसह भारत-निर्मित.",
        stat: "९६%",
        statLabel: "सर्वोच्च कार्यक्षमता"
      }
    }
  },
  bookPage: {
    metaTitle: "डेमो बुक करा आणि AutoNxt शी संपर्क साधा | इलेक्ट्रिक ट्रॅक्टर्स",
    metaDescription: "AutoNxt इलेक्ट्रिक ट्रॅक्टरची टेस्ट ड्राईव्ह बुक करा. आजच शाश्वत, हुशार शेतीकडे पाऊल टाका.",
    tag: "ऑटोनेक्स्टशी संपर्क साधा",
    title: "चला बनवूया ",
    titleHighlight: "भविष्य.",
    desc: "आमच्या इलेक्ट्रिक ट्रॅक्टर्सबद्दल प्रश्न आहेत किंवा डेमो शेड्यूल करू इच्छिता? ऑटोनेक्स्ट टीमशी संपर्क साधा आणि शाश्वत गतिशीलतेचे भविष्य जाणून घ्या.",
    stats: {
      support: "समर्थन",
      supportVal: "२४/७",
      locations: "स्थाने",
      locationsVal: "अखिल भारतीय",
      response: "प्रतिक्षा वेळ",
      responseVal: "< २४ तास"
    },
    form: {
      send: "संदेश पाठवा",
      desc: "खालील फॉर्म भरा आणि आमची टीम लवकरच तुमच्याशी संपर्क साधेल.",
      name: "पूर्ण नाव",
      email: "ईमेल पत्ता",
      phone: "फोन नंबर",
      location: "पसंतीचे ठिकाण",
      model: "ट्रॅक्टर मॉडेल",
      date: "पसंतीची तारीख",
      subject: "विषय",
      message: "तुमचा संदेश",
      submitting: "पाठवत आहे...",
      submitBtn: "बुकिंग सबमिट करा",
      success: "बुकिंग यशस्वीरित्या सबमिट झाले! आम्ही लवकरच तुमच्याशी संपर्क साधू.",
      help: "तुमच्या शेतीच्या गरजा / प्रश्नांचे वर्णन करा...",
      submitCall: "मला आताच कॉल करा",
      scheduleCall: "कॉल शेड्युल विनंती",
      city: "शहर / जिल्हा",
      topic: "मीटिंगचा विषय / प्रश्न"
    },

    contactInfo: {
      title: "संपर्क साधा",
      call: "आम्हाला कॉल करा",
      email: "आम्हाला ईमेल करा",
      visit: "भेट द्या",
      visitVal: "७०४ आणि ७०५ एम्फोटेक आयटी पार्क, ठाणे, महाराष्ट्र",
      hours: "कामाची वेळ",
      hoursVal: "सोमवार - शनिवार, सकाळी ९ ते संध्याकाळी ६"
    },
    cta: {
      tag: "टेस्ट ड्राइव्ह",
      title: "नवकल्पनेचा अनुभव घ्या",
      desc: "आपल्या जवळच्या ठिकाणी इलेक्ट्रिक ट्रॅक्टरच्या थेट डेमोची वेळ निश्चित करा.",
      btn: "टेस्ट ड्राइव्ह बुक करा"
    }
  },
  tractorDetailPage: {
    texts: {
      allTractors: "सर्व ट्रॅक्टर्स",
      comingSoon: "लवकरच येत आहे",
      availableNow: "आता उपलब्ध आहे",
      reserveNow: "आता बुक करा",
      registerInterest: "उत्सुकता नोंदवा",
      bookTestDrive: "टेस्ट ड्राइव्ह बुक करा",
      technicalSpecs: "तांत्रिक तपशील",
      fullSpecs: "पूर्ण तपशील — ",
      keyFeatures: "मुख्य वैशिष्ट्ये",
      whatSetsApart: "जे याला वेगळे करते",
      coreTech: "मूळ तंत्रज्ञान",
      applications: "उपयोग",
      whereWorksBest: "जिथे हे सर्वोत्तम काम करते",
      costComparison5Year: "५ वर्षांची खर्च तुलना",
      dieselTractor45HP: "डिझेल ट्रॅक्टर (45HP)",
      dieselFuelMaint: "₹८-१२ लाख/वर्ष इंधन · ₹१.५ लाख/वर्ष सर्व्हिस",
      electricFuelMaint: "₹१.२-२ लाख/वर्ष वीज · ₹४० हजार/वर्ष सर्व्हिस",
      dieselSavingsNote: "डिझेलच्या तुलनेत ५ वर्षांत ₹३५–५० लाख वाचवा",
      basedOnUsageNote: "दिवसाला ८ तास, वर्षाला ३०० दिवस कामावर आधारित",
      getTractor: "ट्रॅक्टर मिळवा",
      registerTractor: "ट्रॅक्टरसाठी नोंदणी करा",
      ctaDescAvailable: "आपले युनिट आरक्षित करा, टेस्ट ड्राइव्ह बुक करा किंवा सानुकूल कोटसाठी आमच्या टीमशी बोला.",
      ctaDescUpcoming: "आपली उत्सुकता नोंदवा आणि उत्पादन लाँच झाल्यावर प्राधान्य वितरण सूचना मिळवा.",
      compareAllModels: "सर्व मॉडेल्सची तुलना करा",
    },
    tractors: {
      x45h2: {
        name: "AutoNxt X45H2",
        type: "45HP इलेक्ट्रिक ट्रॅक्टर",
        badge: "फ्लॅगशिप",
        badgeColor: "bg-primary",
        tagline: "भारतातील सर्वात शक्तिशाली इलेक्ट्रिक ट्रॅक्टर",
        desc: "X45H2 हे ऑटोनेक्स्टचे प्रमुख कृषी आणि औद्योगिक इलेक्ट्रिक ट्रॅक्टर आहे. मोठे शेत, साखर कारखाने, सिमेंट प्लांट्स आणि बांधकाम साइट्सवर जड कामांसाठी डिझाइन केलेले — हे ४५HP चा झटपट इलेक्ट्रिक टॉर्क, ८+ तासांचा रनटाइम आणि शून्य थेट उत्सर्जन प्रदान करते. भारतातील iCAT-प्रमाणित इलेक्ट्रिक ट्रॅक्टर, आता संपूर्ण भारतात व्यावसायिकरित्या उपलब्ध आहे।",
        image: "/3dmodel/x45h2.glb",
        glbSrc: "/3dmodel/x45h2.glb",
        status: "available",
        specs: [
          { label: "पॉवर (शक्ती)", value: "32 kW (45HP च्या समतुल्य)" },
          { label: "बॅटरी क्षमता", value: "38.4 kWh (सामान्य LFP)" },
          { label: "चार्जर्स", value: "AC 6.6 kW / AC फास्ट 13.4 kW" },
          { label: "चार्जिंग वेळ", value: "DC फास्ट: 60kW - 45 मिनिटे" },
          { label: "कमाल टॉर्क", value: "214 NM" },
          { label: "वजन", value: "2.4 टन" },
          { label: "उचलण्याची क्षमता", value: "1800 kg" },
          { label: "वेग मर्यादा", value: "1.9 - 35 किमी / तास" },
          { label: "पीटीओ पॉवर", value: "24.5 kW / 33 HP" },
          { label: "इंजिन कूलिंग", value: "वाटर कूल्ड मोटर" },
          { label: "टेलिमॅटिक्स", value: "सक्षम" },
          { label: "बॅटरी वॉरंटी", value: "6 वर्षे / 6000 तास" },
        ],
        features: [
          {
            title: "रिमोट फ्लीट टेलिमॅटिक्स",
            desc: "ऑटोनेक्स्ट क्लाउड प्लॅटफॉर्मद्वारे रिअल-टाइम जीपीएस ट्रॅकिंग, बॅटरीची स्थिती, मोटर आरोग्य आणि जिओ-फेन्सिंग — कोणत्याही डिव्हाइसवरून प्रवेशयोग्य."
          },
          {
            title: "एआई-असिस्टेड लोड व्यवस्थापन",
            desc: "बुद्धिमान वीज वितरण प्रणाली लोड आणि भूप्रदेशाच्या आधारे टॉर्क आउटपुट आणि रिजेन ब्रेकिंग स्वयंचलितपणे ऑप्टिमाइझ करते."
          },
        ],
        battery: [
          { label: "केमिस्ट्री", value: "लिथियम आयरन फॉस्फेट (LFP)" },
          { label: "क्षमता", value: "38.4 kWh" },
          { label: "सेल सायकल लाइफ", value: "2,000+" },
          { label: "आयपी रेटिंग", value: "IP67" },
          { label: "कूलिंग", value: "सक्रिय लिक्विड कूलिंग" },
        ],
        motor: [
          { label: "प्रकार", value: "परमनंट मॅग्नेट सिंक्रोनस मोटर" },
          { label: "सर्वोच्च शक्ती", value: "32 kW (45 HP)" },
          { label: "सर्वोच्च टॉर्क", value: "280 Nm" },
          { label: "सर्वोच्च कार्यक्षमता", value: "96%" },
        ],
        applications: [
          "मोठ्या प्रमाणावर भात आणि गव्हाची शेती",
          "साखर कारखान्यातील वाहतूक आणि गाळप कामे",
          "बायोमास बेलिंग आणि वाहतूक",
          "सिमेंट पानांमध्ये साहित्य हाताळणी",
          "बांधकाम साइट माती तयार करणे",
          "विमानतळ ग्राउंड सपोर्ट ऑपरेशन्स",
          "धातु प्लांट अंतर्गत लॉजिस्टिक्स",
        ],
        highlights: [
          "भारतातील iCAT-प्रमाणित इलेक्ट्रिक ट्रॅक्टर",
          "पहिली व्यावसायिक वितरण: जयवंत शुगर्स लि., कराड (मार्च २०२४)",
          "आता उपलब्ध आहे — उत्पादन युनिट्स वितरणासाठी सज्ज",
          "FAME-III आणि राज्य ईव्ही सबसिडीसाठी पात्र",
          "६ वर्षांची व्यापक वॉरंटी",
          "मेड इन इंडिया — ठाणे, महाराष्ट्र",
        ],
      },
      h55c2: {
        name: "AutoNxt H55C2",
        type: "55HP इलेक्ट्रिक ट्रॅक्टर",
        badge: "उच्च कार्यक्षमता",
        badgeColor: "bg-accent",
        tagline: "मागणी असलेल्या कृषी आणि औद्योगिक कार्यांसाठी उच्च-कार्यक्षमता इलेक्ट्रिक पावर",
        desc: "H55C2 मोठ्या प्रमाणावरील कृषी आणि औद्योगिक कामांसाठी ऑटोनेक्स्टचे सर्वात शक्तिशाली शून्य-उत्सर्जन इलेक्ट्रिक ड्राइव्हट्रेन आणते. 45 kW PMSM मोटर आणि 63.89 kwh LFP लिक्विड-कूल्ड बॅटरीसह, हे 410 NM टॉर्क आणि रेटेड लोडसह 80 किमी रेंज देते.",
        image: "/3dmodel/h55c2.glb",
        glbSrc: "/3dmodel/h55c2.glb",
        status: "available",
        specs: [
          { label: "मोटर पॉवर", value: "45 kW (55 HP समतुल्य)" },
          { label: "बॅटरी क्षमता", value: "63.89 kwh (LFP लिक्विड कूल्ड)" },
          { label: "चार्जर (AC)", value: "AC फास्ट - 13.2 kW (ऑफ-बोर्ड, पर्यायी) III फेज" },
          { label: "DC फास्ट चार्जर", value: "DC फास्ट - 40kW (ऑफ-बोर्ड, पर्यायी) DUAL Gun" },
          { label: "गेयर", value: "8F + 2R" },
          { label: "कमाल टॉर्क", value: "410 NM" },
          { label: "वजन", value: "~2.8 टन" },
          { label: "उचलण्याची क्षमता", value: "2800 kg" },
          { label: "वेग मर्यादा", value: "1.9 – 35 किमी/तास" },
          { label: "पीटीओ पॉवर", value: "24.5 kW / 32.8 HP" },
          { label: "ट्रान्समिशन", value: "Constant Mesh (Carraro)" },
          { label: "टेलिमॅटिक्स", value: "सक्षम" },
          { label: "बॅटरी वॉरंटी", value: "५ वर्षे / १५०० चार्जिंग सायकल" },
          { label: "रेंज", value: "रेटेड लोडसह 80 किमी" },
        ],
        features: [
          {
            title: "लिक्विड-कूल्ड LFP बॅटरी पॅक",
            desc: "प्रगत 63.89 kwh LFP बॅटरी लिक्विड कूलिंगसह जड भार आणि अत्यंत तापमानात देखील स्थिर वीज पुरवठा सुनिश्चित करते."
          },
          {
            title: "Carraro कॉन्स्टंट मेश ट्रान्समिशन",
            desc: "8F + 2R गिअर आणि साइड शिफ्टसह हेवी-ड्यूटी Carraro ट्रान्समिशन औद्योगिक-दर्जाच्या कामांसाठी अचूक नियंत्रण आणि जास्तीत जास्त टिकाऊपणा प्रदान करते."
          },
          {
            title: "दुहेरी चार्जिंग पर्याय",
            desc: "DUAL Gun क्षमतेसह AC फास्ट (13.2 kW) आणि DC फास्ट (40 kW) चार्जिंगला सपोर्ट करते, जे निरंतर कामासाठी लवचिक आणि जलद रिचार्जिंग सक्षम करते."
          },
        ],
        battery: [
          { label: "केमिस्ट्री", value: "लिथियम आयरन फॉस्फेट (LFP)" },
          { label: "क्षमता", value: "63.89 kwh (लिक्विड कूल्ड)" },
          { label: "सेल सायकल लाइफ", value: "१,५०० चार्जिंग-डिस्चार्ज सायकल" },
          { label: "वॉरंटी", value: "५ वर्षे / १५०० चार्जिंग सायकल (जे आधी असेल ते)" },
          { label: "आयपी रेटिंग", value: "IP67" },
          { label: "कूलिंग", value: "सक्रिय लिक्विड कूलिंग सिस्टम" },
        ],
        motor: [
          { label: "प्रकार", value: "PMSM (परमनंट मॅग्नेट सिंक्रोनस मोटर)" },
          { label: "पीक पॉवर", value: "45 kW (55 HP समतुल्य)" },
          { label: "पीक टॉर्क", value: "410 NM" },
          { label: "रेटेड RPM", value: "2200 RPM" },
          { label: "कूलिंग", value: "वॉटर कूल्ड मोटर" },
          { label: "पीक कार्यक्षमता", value: "96%" },
        ],
        applications: [
          "मोठ्या प्रमाणावरील व्यावसायिक शेती कार्य",
          "जड मातीची मशागत आणि खोल नांगरणी",
          "औद्योगिक साहित्य हाताळणी आणि लॉजिस्टिक्स",
          "१८ टनांपर्यंत जड वाहतूक",
          "बांधकाम साइट ऑपरेशन्स",
          "नगरपालिका आणि सरकारी ताफा कार्यक्रम",
        ],
        highlights: [
          "ऑटोनेक्स्टच्या श्रेणीतील सर्वात शक्तिशाली इलेक्ट्रिक ट्रॅक्टर",
          "63.89 kwh लिक्विड-कूल्ड LFP बॅटरी — रेटेड लोडसह 80 किमी रेंज",
          "Carraro ट्रान्समिशनसह 410 NM पीक टॉर्क",
          "दुहेरी चार्जिंग: AC फास्ट 13.2 kW + DC फास्ट 40 kW DUAL Gun",
          "2800 kg हायड्रोलिक लिफ्टिंग क्षमता",
          "5-वर्षांची बॅटरी वॉरंटी 1500 चार्ज सायकलसह",
          "भारतामध्ये निर्मित — ठाणे, महाराष्ट्र",
        ],
      },
      x45c2: {
        name: "AutoNxt X45C2",
        type: "45HP इलेक्ट्रिक ट्रॅक्टर",
        badge: "उच्च कार्यक्षमता",
        badgeColor: "bg-emerald-700",
        tagline: "व्यावसायिक दर्जाचे उच्च कार्यक्षमता इलेक्ट्रिक ट्रॅक्टर",
        desc: "X45C2 हे ऑटोनेक्स्टचे उच्च कार्यक्षमतेचे कृषी आणि औद्योगिक इलेक्ट्रिक ट्रॅक्टर आहे. व्यावसायिक शेती आणि जड-ड्यूटी औद्योगिक कामांसाठी डिझाइन केलेले, यात 32 kW ची PMSM इलेक्ट्रिक मोटर, 38.4 kWh LFP04 प्रिझमॅटिक बॅटरी पॅक आणि रेटेड लोडसह 60 किमीची रेंज आहे. सर्वात कठीण वातावरणासाठी सर्वोच्च टॉर्क आणि शून्य थेट उत्सर्जन देण्यासाठी डिझाइन केलेले.",
        image: "/3dmodel/x45.glb",
        glbSrc: "/3dmodel/x45.glb",
        status: "available",
        specs: [
          { label: "मोटर शक्ती", value: "32 kW (45 HP), PMSM" },
          { label: "बॅटरी क्षमता", value: "[लिथियम फेरो फॉस्फेट] LFP04 प्रिझमॅटिक, 38.4 kWh" },
          { label: "रेंज", value: "रेटेड लोडसह 60 किमी" },
          { label: "चार्जर", value: "AC स्लो 6.6 kW (ऑनबोर्ड) + AC फास्ट 13.2 kW (ऑफ-बोर्ड)" },
          { label: "कमाल टॉर्क", value: "223 NM" },
          { label: "वजन", value: "~2.3 टन" },
          { label: "उचलण्याची क्षमता", value: "1800 kg" },
          { label: "कमाल वेग", value: "35 किमी/तास" },
          { label: "पीटीओ शक्ती", value: "24.5 kW / 32.8 HP, 540E आणि 540 RPM" },
          { label: "कूलिंग", value: "वॉटर कूल्ड मोटर" },
          { label: "ट्रांसमिशन", value: "कॉन्स्टंट मेश (कॅरारो), 1800 RPM" },
          { label: "वॉरण्टी", value: "मोटर ३+२ वर्षे, बॅटरी 1500 सायकल/५ वर्षे" },
        ],
        features: [
          {
            title: "LFP04 प्रिझमॅटिक बॅटरी पॅक",
            desc: "अत्यंत हवामानात स्थिर उर्जा वितरणासाठी 38.4 kWh क्षमता आणि 1500+ सायकल आयुष्यासह प्रगत LFP04 प्रिझमॅटिक बॅटरी केमिस्ट्री."
          },
          {
            title: "रिमोट फ्लीट टेलिमॅटिक्स",
            desc: "रिअल-टाइम जीपीएस ट्रॅकिंग, बॅटरी स्थिती, motor आरोग्य आणि ऑटोनेक्स्ट क्लाउड प्लॅटफॉर्मद्वारे जिओ-फेन्सिंग — कोणत्याही उपकरणावरून उपलब्ध."
          },
        ],
        battery: [
          { label: "केमिस्ट्री", value: "लिथियम आयरन फॉस्फेट (LFP04 प्रिझमॅटिक)" },
          { label: "क्षमता", value: "38.4 kWh" },
          { label: "सेल सायकल लाइफ", value: "१५०० चार्जिंग - डिस्चार्ज सायकल" },
          { label: "वॉरंटी", value: "५ वर्षे / 1500 सायकल (जे आधी असेल ते)" },
          { label: "ऑनबोर्ड चार्जर", value: "होय (6.6 kW AC स्लो चार्जर अंगभूत)" },
        ],
        motor: [
          { label: "प्रकार", value: "PMSM (परमनंट मॅग्नेट सिंक्रोनस मोटर)" },
          { label: "मोटर शक्ती", value: "32 kW (45 HP)" },
          { label: "सर्वोच्च टॉर्क", value: "223 NM" },
          { label: "कूलिंग", value: "वॉटर कूल्ड मोटर" },
        ],
        applications: [
          "मध्यम-ते-जड स्तरावरील शेती ऑपरेशन्स",
          "मातीची मशागत आणि बियाणे पेरणी",
          "१० टनांपर्यंत वाहतूक आणि पेलोड हाताळणी",
          "बागकाम, द्राक्षबागा आणि ओळीतील पीक व्यवस्थापन",
          "औद्योगिक कारखान्यातील अंतर्गत लॉजिस्टिक्स",
        ],
        highlights: [
          "ऑटोनेक्स्टचे उच्च कार्यक्षमतेचे जड-ड्यूटी इलेक्ट्रिक ट्रॅक्टर",
          "38.4 kWh LFP04 प्रिझमॅटिक बॅटरी पॅकसह कमाल रनटाइम",
          "वॉटर कूल्ड PMSM मोटर — 32 kW / 45 HP",
          "१० टन कमाल रेटेड लोड पेलोड हाताळण्यास सक्षम",
          "मोटर ३+२ वर्षे | बॅटरी 1500 सायकल/५ वर्षे वॉरंटी",
          "भारतामध्ये निर्मित — ठाणे, महाराष्ट्र",
        ],
      },
    }
  },
  industryPage: {
    metaTitle: "उद्योगानुसार इलेक्ट्रिक ट्रॅक्टर्स | AutoNxt",
    metaDescription: "विविध क्षेत्रांमधील AutoNxt इलेक्ट्रिक वाहने पाहा: शेती, बांधकाम, विमानतळ, बायोमास, धातू आणि संरक्षण.",
    texts: {
      indSol: "औद्योगिक सोल्यूशन्स",
      heroTitlePre: "भारतातील सर्वात कठीण उद्योगांना ",
      heroTitleHighlight: "सक्षम बनवणे",
      heroTitlePost: ".",
      heroDesc: "इलेक्ट्रिक ट्रॅक्टर सोल्यूशन्स जे खडबडीत, शून्य-उत्सर्जन आणि भारतातील सर्वात कठीण वातावरणासाठी बनवले आहेत.",
      industriesLabel: "उद्योग",
      applicationsLabel: "अनुप्रयोग",
      certifiedLabel: "प्रमाणित",
      ourSolutions: "आमचे सोल्यूशन्स",
      solHeading: "सहा उद्योग. एक ईव्ही प्लॅटफॉर्म.",
      solDesc: "ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर्स भारतातील सर्वात आव्हानात्मक वातावरणात निरंतर कामासाठी बनवले आहेत.",
      learnMore: "अधिक जाणा",
      ourTractors: "आमचे ट्रॅक्टर्स",
      tractorsHeading: "प्रत्येक कामासाठी योग्य ट्रॅक्टर.",
      tractorsDesc: "औद्योगिक आणि कृषी कामांसाठी विशेषतः बनवलेल्या इलेक्ट्रिक ट्रॅक्टर्सच्या आमच्या वाढत असलेल्या श्रेणीमधून निवडा.",
      electricTractor: "इलेक्ट्रिक ट्रॅक्टर",
      viewDetails: "तपशील पाहा",
      dontSeeSector: "आपले क्षेत्र दिसत नाही का?",
      ctaDesc: "आमचे प्लॅटफॉर्म असीमितपणे जुळवून घेणारे आहे. सानुकूल औद्योगिक भागीदारी एक्सप्लोर करण्यासाठी आमच्या टीमशी बोला.",
      talkToUs: "आमच्याशी बोला",
    },
    industries: [
      {
        title: "बायोमास",
        slug: "biomass",
        short: "BIO",
        desc: "शून्य उत्सर्जन आणि कमी परिचालन खर्चासह बायोमास संकलन, प्रक्रिया आणि वाहतुकीत क्रांती घडवून आणा.",
        detail: "ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर्स बायोमास कामांमध्ये कार्यक्षमता पुन्हा परिभाषित करतात. बायोमास संकलन, प्रक्रिया आणि वाहतुकीसाठी डिझाइन केलेले आमचे ट्रॅक्टर्स प्रत्येक चक्रात विश्वसनीयता आणि शाश्वतता प्रदान करतात.",
        bg: "bg-lime-700",
        img: "/images/doubletrolleysidedroneview.webp",
      },
      {
        title: "सिमेंट निर्मिती",
        short: "CEMENT",
        slug: "cement",
        desc: "सिमेंट प्लांटमधील सामग्री हाताळणी, वाहतूक आणि साइट देखभाल ऑप्टिमाइझ करा — डाउनटाइम कमी करा आणि उत्पादकता वाढवा.",
        detail: "सिमेंट निर्मितीमध्ये ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर्सच्या शक्तीचा अनुभव घ्या. आमचे ट्रॅक्टर्स शून्य उत्सर्जन आणि प्रगत वैशिष्ट्यांसह सामग्री हाताळणी, वाहतूक आणि साइट देखभाल ऑप्टिमाइझ करतात.",
        bg: "bg-orange-700",
        img: "/images/cement_industry.webp",
      },
      {
        title: "बांधकाम उद्योग",
        short: "CONST.",
        slug: "construction",
        desc: "Site तयार करणे, सामग्री हाताळणी आणि उपकरणे वाहतुकीसाठी अतुलनीय बहुमुखी प्रतिभा आणि शक्ती — हरित बांधकामाकडे वाटचाल.",
        detail: "ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर्स हे बांधकामाचे भविष्य आहेत. अतुलनीय बहुमुखी प्रतिभा आणि शक्तीसह, ते साइट तयार करणे, सामग्री हाताळणी आणि उपकरणे वाहतूक यामध्ये उत्कृष्ट कामगिरी करतात.",
        bg: "bg-yellow-700",
        img: "/images/construction_industry.webp",
      },
      {
        title: "संरक्षण क्षेत्र",
        short: "DEF.",
        slug: "defence",
        desc: "लष्करी लॉजिस्टिक्स, बेस मेंटेनन्स आणि ऑल-टेरेन ऑपरेशन्ससाठी उत्कृष्ट कामगिरी आणि खडबडीत टिकाऊपणा, रिमोट ऑपरेशनच्या पर्यायांसह.",
        detail: "ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर्स संरक्षण अनुप्रयोगांसाठी उत्कृष्ट कामगिरी आणि खडबडीत टिकाऊपणा देतात. लॉजिस्टिक्स समर्थनापासून ते बेस मेंटेनन्सपर्यंत, ते सर्वात कठीण लष्करी वातावरणात उत्कृष्ट कामगिरी करतात.",
        bg: "bg-slate-700",
        img: "/images/implements.webp",
      },
      {
        title: "विमानतळ ऑपरेशन्स",
        short: "AIRPORT",
        slug: "airport",
        desc: "बॅगेज हाताळणीपासून ते रनवे देखभालीपर्यंत — अधिक सुलभ आणि हरित विमानतळ ऑपरेशन्ससाठी शून्य-उत्सर्जन, स्वायत्त-सज्ज ट्रॅक्टर्स.",
        detail: "ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर्स विमानतळ ऑपरेशन्स पुन्हा परिभाषित करतात. बॅगेज हाताळणीपासून ते रनवे देखभालीपर्यंत, आमचे ट्रॅक्टर्स शून्य उत्सर्जन and प्रगत स्वायत्त नेव्हिगेशन वैशिष्ट्ये देतात.",
        bg: "bg-sky-700",
        img: "/images/facility/garage-entry.webp",
      },
      {
        title: "धातु निर्मिती",
        short: "METAL",
        slug: "metal",
        desc: "सामग्री हाताळणीपासून ते लॉजिस्टिक्सपर्यंत, आमचे ट्रॅक्टर्स पर्यावरणावरील प्रभाव कमी करताना धातू निर्मिती ऑपरेशन्स सुव्यवस्थित करतात.",
        detail: "ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर्स धातू निर्मितीमध्ये कार्यक्षमता पुन्हा परिभाषित करतात. सामग्री हाताळणीपासून ते लॉजिस्टिक्सपर्यंत, आमचे ट्रॅक्टर्स पर्यावरणीय प्रभाव कमी करताना ऑपरेशन्स सुव्यवस्थित करतात.",
        bg: "bg-slate-600",
        img: "/images/videos/loaders-grabbers-thumbnail.webp",
      },
    ],
    tractors: [
      {
        img: "/images/products/x45h2.webp",
        name: "AutoNxt X45H2",
        slug: "x45h2",
        hp: "45HP",
        status: "available",
        statusLabel: "आता उपलब्ध आहे",
        desc: "शेती आणि बांधकामासाठी योग्य असलेला एक शक्तिशाली 45HP ट्रॅक्टर. पारंपारिक 35-55 HP डिझेल ट्रॅक्टर्सच्या कामगिरीशी जुळणारा, शेती आणि वाहतूक उपक्रमांसाठी आदर्श.",
        specs: [
          { label: "मोटर", value: "32 kW" },
          { label: "बॅटरी", value: "38.4 kWh" },
          { label: "रेंज", value: "50 km" },
        ],
        accentBg: "bg-primary/5",
        accentBorder: "border-primary/20",
        tagColor: "bg-emerald-500",
      },
      {
        img: "/images/products/h55c2.webp",
        name: "AutoNxt H55C2",
        slug: "h55c2",
        hp: "55HP Equivalent",
        status: "available",
        statusLabel: "आता उपलब्ध आहे",
        desc: "63.89 kwh लिक्विड-कूल्ड LFP बॅटरी, कॅरारो ट्रान्समिशन, 410 NM टॉर्क आणि 80 किमी रेंजसह उच्च कार्यक्षमतेचा 55HP समकक्ष इलेक्ट्रिक ट्रॅक्टर. भारी कृषी आणि औद्योगिक कार्यासाठी निर्मित.",
        specs: [
          { label: "मोटर", value: "45 kW" },
          { label: "बॅटरी", value: "63.89 kwh" },
          { label: "रेंज", value: "80 km" },
        ],
        accentBg: "bg-accent/5",
        accentBorder: "border-accent/20",
        tagColor: "bg-accent",
      },
      {
        img: "/images/products/x45h2.webp",
        name: "AutoNxt X45C2",
        slug: "x45c2",
        hp: "45HP",
        status: "available",
        statusLabel: "आता उपलब्ध आहे",
        desc: "मध्यम-ते-जड प्रमाणावरील कामांसाठी प्रगत वैशिष्ट्यांसह उच्च कार्यक्षमतेचा 45HP ट्रॅक्टर. जास्तीत जास्त कार्यक्षमता आणि शून्य-उत्सर्जन शाश्वततेचा एक आदर्श समतोल.",
        specs: [
          { label: "मोटर", value: "32 kW" },
          { label: "बॅटरी", value: "38.4 kWh" },
          { label: "रेंज", value: "60 km" },
        ],
        accentBg: "bg-primary/5",
        accentBorder: "border-primary/20",
        tagColor: "bg-emerald-500",
      },
    ]
  },
  industryDetailPage: {
    texts: {
      industryNotFound: "उद्योग आढळला नाही",
      backToIndustries: "← उद्योगांकडे परत",
      allIndustries: "सर्व उद्योग",
      overview: "आढावा",
      challenge: "आव्हान",
      theAutoNxtSolution: "ऑटोनेक्स्ट सोल्यूशन",
      keyApplications: "मुख्य अनुप्रयोग",
      whatAutoNxtDoes: "ऑटोनेक्स्ट येथे काय करते",
      whyAutoNxt: "ऑटोनेक्स्ट का",
      builtFor: "साठी बनवलेले.",
      electricMotor: "इलेक्ट्रिक मोटर",
      torque0Rpm: "० आरपीएमपासून झटपट पूर्ण टॉर्क",
      batteryRange: "बॅटरी रेंज",
      perChargeDuty: "सतत ड्युटी सायकलमध्ये प्रति charge",
      chargeTime: "चार्ज वेळ",
      acChargingStandard: "मानक औद्योगिक पुरवठ्यावरून एसी चार्जिंग",
      fleetSupport: "ताफा समर्थन",
      remoteDiagnostics: "रिमोट डायग्नोस्टिक्स आणि टेलिमॅटिक्स",
      recommendedModels: "शिफारस केलेले मॉडेल्स",
      rightTractorFor: "साठी योग्य ट्रॅक्टर",
      viewFullSpecs: "पूर्ण तपशील पाहा",
      readyToGoElectric: "मध्ये इलेक्ट्रिक जाण्यास तयार आहात का?",
      ctaDesc: "आमच्या औद्योगिक सोल्यूशन्स टीमशी बोला. आम्ही तुम्हाला ताफ्याची आवश्यकता, charge पायाभूत सुविधा आणि TCO बचतीचे मूल्यांकन करण्यात मदत करू.",
      bookConsultation: "सल्लामसलत बुक करा",
    },
    industries: {
      biomass: {
        title: "बायोमास",
        badge: "BIOMASS",
        tagline: "शून्य-उत्सर्जन बायोमास संकलन आणि प्रक्रिया",
        desc: "भारत दरवर्षी ५० कोटी टनांपेक्षा जास्त कृषी बायोमास निर्माण करतो. ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर्स बायोमास संकलन, बेलिंग, वाहतूक आणि प्रक्रियेच्या विशिष्ट मागण्यांसाठी डिझाइन केलेले आहेत — जे साठवणूक आणि प्रक्रिया केंद्रांमध्ये जास्त अपटाइम, कमी प्रति-टन खर्च आणि शून्य निकास उत्सर्जन देतात.",
        bg: "bg-lime-700",
        image: "/images/doubletrolleysidedroneview.webp",
        applications: [
          {
            title: "बायोमास वाहतूक",
            desc: "कोणतीही उष्णता आणि डिझेल निकास न सोडता बंद बायोमास बेजमध्ये लोड केलेले बायोमास ट्रेलर्स सतत उच्च टॉर्कसह ओढा."
          },
          {
            title: "बेलिंग ऑपरेशन्स",
            desc: "सतत पीटीओ आउटपुटसह गोल आणि चौकोनी बेलर्स चालवा. ट्रॅक्टरचा इलेक्ट्रिक टॉर्क कर्व इंजिन बंद न होता बेलरच्या वाढत्या लोडसाठी आदर्श आहे."
          },
          {
            title: "प्लांटच्या आत वाहतूक",
            desc: "प्रक्रिया केंद्रांच्या आत बायोमास बेल्स हलवा जिथे डिझेलचा धूर आरोग्यास धोकादायक आहे. ऑटोनेक्स्टचे शून्य-उत्सर्जन कार्य या बंद वातावरणासाठी सुरक्षित आहे."
          },
          {
            title: "शेत संकलन",
            desc: "प्रति चार्ज ८+ तासांच्या रनटाइमसह शेतातून संकलन. स्मार्ट टेलिमॅटिक्स संकलन मार्ग ऑप्टिमाइझ करते."
          },
        ],
        benefits: [
          "५ वर्षांत डिझेलच्या तुलनेत ७०% कमी परिचालन खर्च",
          "शून्य धूर — इनडोअर बायोमास साठवणूक आणि प्रक्रियेसाठी सुरक्षित",
          "प्रति चार्ज ८-१० तास सतत कार्य",
          "व्यावसायिक कृषी वापरासाठी iCAT प्रमाणित",
          "सौर चार्जिंग ग्रिडवरील अवलंबित्व कमी करते",
          "ऑटोनेक्स्ट टेलिमॅटिक्स पोर्टलद्वारे रिमोट ताफा देखरेख",
        ],
        challenges: "बायोमास ऑपरेशन्स लांब शिफ्टमध्ये चालतात, बऱ्याचदा शेडच्या आत जिथे डिझेलचा धूर हवेची गुणवत्ता आणि आगीचा गंभीर धोका निर्माण करतो. इंधनाचा उच्च खर्च नफा कमी करतो, आणि सुगीच्या हंगामात अनपेक्षित देखभालीमुळे संपूर्ण पुरवठा साखळी विस्कळीत होते.",
        solution: "ऑटोनेक्स्ट X45H2 शून्य निकास उत्सर्जनासह ४५HP का झटपट इलेक्ट्रिक टॉर्क देतो, ज्यामुळे ते बायोमास प्रक्रिया केंद्रांच्या आत सुरक्षित बनते. ८+ तासांचा रनटाइम आणि ४ तासांच्या चार्ज चक्रासह, केंद्रे रात्रभर चार्जिंगचा वापर करून एकाच ट्रॅक्टरसह दोन शिफ्ट चालवू शकतात.",
        models: [
          { name: "AutoNxt X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "बायोमास वाहतूक आणि बेलिंगसाठी प्राथमिक पर्याय", slug: "x45h2" },
          { name: "AutoNxt H55C2", hp: "55 HP", img: "/images/products/h55c2.webp", note: "जड बायोमास संकलन आणि औद्योगिक कामांसाठी उच्च कार्यक्षमतेचा पर्याय", slug: "h55c2" },
        ],
      },
      cement: {
        title: "सिमेंट निर्मिती",
        badge: "CEMENT",
        tagline: "स्वच्छ, शांत सिमेंट प्लांट ऑपरेशन्स",
        desc: "सिमेंट प्लांट हे धूळ-भारी, गोंगाट असलेले आणि इंधनावर अवलंबून असणारे वातावरण आहेत. ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर्स अंतर्गत लॉजिस्टिक्स बदलतात — कच्च्या मालाच्या हाताळणीपासून ते क्लिंकर वाहतुकीपर्यंत — परिचालन उत्सर्जन कमी करतात आणि नाट्यमयरीत्या खर्च वाचवतात.",
        bg: "bg-orange-700",
        image: "/images/cement_industry.webp",
        applications: [
          {
            title: "कच्च्या मालाचे लॉजिस्टिक्स",
            desc: "प्लांट कॉरिडोअरमध्ये चुनखडी, माती आणि ॲडिटिव्ह्जची वाहतूक करा. डिझेल टर्ब्युलेन्सच्या तुलनेत इलेक्ट्रिक ऑपरेशन धूळ उडणे कमी करते."
          },
          {
            title: "क्लिंकर वाहतूक",
            desc: "उच्च तापमानाच्या झोनमध्ये ओव्हरहीटिंगची काळजी न करता भट्टी, कुलर आणि सायलो यांच्या दरम्यान क्लिंकर वाहून न्या."
          },
        ],
        benefits: [
          "बंद प्लांट कॉरिडोअरमधील डिझेल निकास पूर्णपणे काढून टाकतो",
          "कमी आवाज २४/७ प्लांट वातावरणात कामगारांचा थकवा कमी करतो",
          "हायड्रॉलिक ऑइल गळती नाही — सिमेंट साठवण क्षेत्राजवळ अत्यंत आवश्यक",
          "जड औद्योगिक वापरासाठी iCAT प्रमाणित",
          "OTA सॉफ्टवेअर अपडेट्स कामगिरी उत्कृष्ट ठेवतात",
          "ताफा टेलिमॅटिक्स प्लांट व्यवस्थापन प्रणालीसह समाकलित होते",
        ],
        challenges: "सिमेंट प्लांट्स केवळ अंतर्गत लॉजिस्टिक्समध्ये दरमहा हजारो लिटर डिझेल वापरतात. उच्च तापमानामुळे डिझेल इंजिन ओव्हरहीट होतात. उत्सर्जन नियम कडक होत आहेत.",
        solution: "ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर्स कोणताही धूर निर्माण करत नाहीत आणि उष्ण वातावरणात थंड चालतात. मॉड्यूलर बॅटरी आर्किटेक्चरसह, संपूर्ण ट्रॅक्टर बंद न करता बॅटरी पॅकची सर्व्हिस केली जाऊ शकते.",
        models: [
          { name: "AutoNxt X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "क्लिंकर वाहतूक आणि जड वाहतुकीसाठी शिफारस केलेले", slug: "x45h2" },
        ],
      },
      construction: {
        title: "बांधकाम उद्योग",
        badge: "CONSTRUCTION",
        tagline: "भारताच्या बिल्डिंग बूमसाठी शाश्वत शक्ती",
        desc: "भारताचे बांधकाम क्षेत्र दरवर्षी लाखो चौरस मीटरचे बांधकाम करते. ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर्स साइट तयार करणे, साहित्य वाहतूक आणि उपकरणे पोझिशनिंगसाठी शून्य-उत्सर्जन, उच्च-टॉर्क कामगिरी आणतात.",
        bg: "bg-yellow-700",
        image: "/images/construction_industry.webp",
        applications: [
          {
            title: "साहित्य वाहतूक",
            desc: "स्थिर, उच्च-टॉर्क इलेक्ट्रिक driveट्रेनसह सक्रिय बांधकाम साइट्सवर वाळू, खडी, विटा आणि स्टीलची वाहतूक करा."
          },
        ],
        benefits: [
          "हरित इमारत साइट उत्सर्जन मानके पूर्ण करते",
          "कमी आवाज — निवासी साइटच्या कामाच्या वेळेच्या निर्बंधांचे पालन करतो",
          "खडबडीत आणि खडी असलेल्या पृष्ठभागासाठी मजबूत चेसिस",
          "उतारावर जड लोड ओढण्यासाठी सर्वोत्तम टॉर्क",
          "SITEवर इंधन साठवणुकीचा धोका नाही — आगीचा धोका कमी होतो",
        ],
        challenges: "बांधकाम साइट्सना विशेषतः शहरी निवासी क्षेत्रांजवळ डिझेल उत्सर्जनावर वाढत्या नियामक दबावाचा सामना करावा लागतो।",
        solution: "ऑटोनेक्स्ट X45H2 चे सीलबंद इलेक्ट्रिक driveट्रेन धुळीमुळे प्रभावित होत नाही. याला कोणत्याही इंधन वितरणाची आवश्यकता नसते आणि बॅटरी रात्री charge केली जाऊ शकते.",
        models: [
          { name: "AutoNxt X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "बांधकाम साइट वाहतूक आणि माती तयार करण्यासाठी प्राथमिक पर्याय", slug: "x45h2" },
        ],
      },
      defence: {
        title: "संरक्षण क्षेत्र",
        badge: "DEFENCE",
        tagline: "शांत. मजबूत. मिशन-सज्ज.",
        desc: "संरक्षण आणि निमलष्करी ऑपरेशन्स अशा उपकरणांची मागणी करतात जी दबावाखाली विश्वसनीय असतील, आणि ज्यांचा आवाज आणि उष्णता कमी असेल. ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर्स बेस लॉजिस्टिक्स, एअरफील्ड सपोर्ट आणि ऑल-टेरेन वापरासाठी डिझाइन केलेले आहेत.",
        bg: "bg-slate-700",
        image: "/images/implements.webp",
        applications: [
          {
            title: "बेस लॉजिस्टिक्स",
            desc: "शून्य आवाजासह लष्करी बेस सुविधांच्या दरम्यान पुरवठा आणि उपकरणे हलवा जेणेकरून सुरक्षितता अधिक मजबूत होईल."
          },
        ],
        benefits: [
          "कमी आवाजाचे इलेक्ट्रिक ऑपरेशन शत्रूच्या पाळतीपासून संरक्षण करते",
          "सायलेन्सरमधून उष्णता उत्सर्जित होत नाही — सुरक्षिततेत सुधारणा",
          "कमी अंतराच्या लॉजिस्टिक्ससाठी इंधनावरील अवलंबित्व पूर्णपणे काढून टाकते",
          "कच्च्या आणि ऑफ-रोड भूप्रदेशासाठी मजबूत चेसिस",
          "कमी देखभालीचा बोजा — इंजिन ऑइल, फिल्टर्स किंवा इंजेक्टर्सची आवश्यकता नाही",
        ],
        challenges: "लष्करी लॉजिस्टिक्सला अशा उपकरणांची आवश्यकता असते जी गुंतागुंतीच्या इंधन लॉजिस्टिक्सशिवाय, विविध भूप्रदेशांवर शांतपणे काम करू शकतील।",
        solution: "ऑटोनेक्स्टचे इलेक्ट्रिक पॉवरट्रेन शांत कार्य करते आणि उष्णता निर्माण करत नाही, जे बेस ऑपरेशन्ससाठी आदर्श आहे. बॅटरी सौर उर्जेद्वारेही चार्ज केली जाऊ शकते.",
        models: [
          { name: "AutoNxt X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "लष्करी बेस लॉजिस्टिक्ससाठी प्राथमिक शिफारस", slug: "x45h2" },
        ],
      },
      airport: {
        title: "विमानतळ ऑपरेशन्स",
        badge: "AIRPORT",
        tagline: "हरित भू-संचालन विमानतळांसाठी",
        desc: "विमानतळांवर जमिनीवरील उत्सर्जन कमी करण्यासाठी प्रचंड दबाव आहे. ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर्स बॅगेज हाताळणी, रनवे देखभाल, मालवाहतूक आणि सुरक्षितता ऑपरेशन्ससाठी आदर्श आहेत.",
        bg: "bg-sky-700",
        image: "/images/facility/garage-entry.webp",
        applications: [
          {
            title: "बॅगेज आणि मालवाहतूक",
            desc: "प्रवासी आणि विमानाजवळ शून्य उत्सर्जनासह टर्मिनल्स, विमाने आणि कार्गो बे दरम्यान बॅगेज ट्रेलर्स ओढा."
          },
        ],
        benefits: [
          "DGCA आणि ICAO च्या उत्सर्जन मानकांचे पूर्णपणे पालन करते",
          "शांत कार्य ATC संवाद सुलभ आणि स्पष्ट करते",
          "शून्य धूर — विमान इंधन साठ्याजवळ अत्यंत महत्त्वाचा सुरक्षितता घटक",
          "हरित भू-संचालन अनुदानासाठी पात्र",
          "ताफा टेलिमॅटिक्स विमानतळ ऑपरेशन्स केंद्रांशी समाकलित होतो",
        ],
        challenges: "विमानतळांना जमिनीवरील उत्सर्जनावर कठोर नियमांचा सामना करावा लागतो. इंधन डेपो जवळ डिझेल वाहने आगीचा धोका निर्माण करतात.",
        solution: "ऑटोनेक्स्टचे शून्य-उत्सर्जन, शांत इलेक्ट्रिक ट्रॅक्टर्स विमानतळाच्या नाजूक वातावरणासाठी आदर्श आहेत. त्यांना रात्री चार्ज केले जाऊ शकते.",
        models: [
          { name: "AutoNxt X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "बॅगेज वाहतूक आणि धावपट्टी देखभालीसाठी शिफारस केलेले", slug: "x45h2" },
        ],
      },
      metal: {
        title: "धातू निर्मिती",
        badge: "METAL",
        tagline: "धातू प्लांटसाठी हेवी-ड्यूटी इलेक्ट्रिक लॉजिस्टिक्स",
        desc: "धातू निर्मिती सुविधांना अंतर्गत लॉजिस्टिक्सची मोठ्या प्रमाणावर आवश्यकता असते. ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर्स उच्च टॉर्कसह जड साहित्य वाहतूक हाताळतात, तर बंद कारखान्यात डिझेलचा धूर पूर्णपणे नष्ट करतात.",
        bg: "bg-slate-600",
        image: "/images/videos/loaders-grabbers-thumbnail.webp",
        applications: [
          {
            title: "कॉइल आणि शीट वाहतूक",
            desc: "जड ट्रेलर लोडसाठी आवश्यक असलेल्या उच्च टॉर्कसह प्लांट लॉजिस्टिक्स कॉरिडोअरमध्ये स्टील कॉइल आणि शीटची वाहतूक करा."
          },
        ],
        benefits: [
          "बंद कारखान्यात आणि वितळवण्याच्या कामात डिझेलचा धूर पूर्णपणे काढून टाकतो",
          "जड धातू ट्रेलर लोडसाठी सतत उच्च टॉर्क प्रदान करतो",
          "धुळीच्या वातावरणासाठी आयपी-रेटेड बॅटरी संरक्षण",
          "ज्वलनशील प्रक्रियेदरम्यान आगीचा धोका लक्षणीयरीत्या कमी करतो",
          "प्लँट-स्तरीय वीज व्यवस्थापन प्रणालीसह सुसंगत",
        ],
        challenges: "धातू प्लँटना तीव्र उष्णता, धूळ आणि कडक हवेच्या गुणवत्तेच्या नियमांना तोंड द्यावे लागते. डिझेलचा धूर आरोग्यासाठी गंभीर धोका निर्माण करतो.",
        solution: "ऑटोनेक्स्ट X45H2 चे सीलबंद इलेक्ट्रिक पॉवरट्रेन धुळीपासून पूर्णपणे सुरक्षित आहे. लिक्विड-कूल्ड बॅटरी पॅक ओव्हरहीट न होता योग्य तापमान राखतो.",
        models: [
          { name: "AutoNxt X45H2", hp: "45 HP", img: "/images/products/x45h2.webp", note: "धातू प्लांट वाहतूक आणि लॉजिस्टिक्ससाठी प्राथमिक पर्याय", slug: "x45h2" },
        ],
      },
    }
  },
  careersPage: {
    texts: {
      careersBadge: "ऑटोनेक्स्टमध्ये करिअर",
      heroTitle1: "शेतीचे ",
      heroTitleHighlight: "भविष्य",
      heroTitle2: " घडवा.",
      heroDesc: "भारतीय शेतीचे विद्युतीकरण करणाऱ्या अभियंते, कृषी तज्ञ आणि व्यवसाय निर्मात्यांच्या टीममध्ये सामील व्हा — एका वेळी एक ट्रॅक्टर.",
      openRolesLabel: "खुल्या जागा",
      locationsLabel: "स्थाने",
      teamSizeLabel: "टीमचा आकार",
      positionsCount: " पदे उपलब्ध",
      locationsVal: "ठाणे · मुंबई",
      teamSizeVal: "१५०+ लोक",
      whyJoinUs: "आमच्यासोबत का सामील व्हावे",
      workOnProblems: "महत्त्वाच्या समस्यांवर काम करा.",
      whyJoinUsDesc: "ऑटोनेक्स्ट भारतातील सर्वात महत्त्वाच्या आव्हानांपैकी एक सोडवत आहे — शेतीला लाखो शेतकऱ्यांसाठी शाश्वत आणि आर्थिकदृष्ट्या सक्षम बनवणे.",
      openPositions: "खुल्या जागा",
      rolesAvailable: " पदे आता उपलब्ध आहेत",
      applyViaEmail: "ईमेलद्वारे अर्ज करा",
      dontSeeRole: "तुमचे पद येथे दिसत नाही का?",
      dontSeeRoleDesc: "आम्ही नेहमीच उत्कृष्ट गुणांच्या शोधात असतो. तुमचा बायोडाटा (CV) आम्हाला पाठवा आणि सांगा की तुम्ही ऑटोनेक्स्टच्या ध्येयात कसे योगदान द्याल.",
      sendOpenApp: "ओपन ॲप्लिकेशन पाठवा",
    },
    perks: [
      { title: "ध्येय-प्रेरित कार्य", desc: "मदत करा कार्बन उत्सर्जन कमी करण्यास — तुम्ही तयार केलेल्या प्रत्येक उत्पादनाचा पर्यावरणावर प्रत्यक्ष चांगला प्रभाव पडतो.", color: "text-primary", bg: "bg-primary/10", border: "border-primary/20" },
      { title: "स्टार्टअप वेग", desc: "सपाट रचना, जलद निर्णय आणि पहिल्या दिवसापासून महत्त्वपूर्ण तांत्रिक आणि व्यावसायिक आव्हानांचे नेतृत्व करण्याची संधी.", color: "text-accent", bg: "bg-accent/10", border: "border-accent/20" },
      { title: "थेट शेताचा अनुभव", desc: "आमचे अभियंते नियमितपणे महाराष्ट्र, पंजाब आणि आंध्र प्रदेशमधील शेतांना भेट देतात — तुम्ही सोडवत असलेल्या समस्येला प्रत्यक्ष पाहाल.", color: "text-emerald-600", bg: "bg-emerald-50", border: "border-emerald-200" },
      { title: "इक्विटी आणि वाढ", desc: "स्पर्धात्मक मोबदला, महत्त्वाच्या पदांसाठी ESOPs आणि ऑटोनेक्स्ट राष्ट्रीय पातळीवर विस्तारत असताना वाढीची स्पष्ट संधी.", color: "text-rose-600", bg: "bg-rose-50", border: "border-rose-200" },
    ],
    roles: [
      {
        title: "वरिष्ठ एम्बेडेड सिस्टम अभियंता",
        dept: "अभियांत्रिकी",
        location: "ठाणे, महाराष्ट्र",
        type: "पूर्णवेळ (Full-time)",
        desc: "ऑटोनेक्स्टच्या इलेक्ट्रिक पॉवरट्रेन, बीएमएस आणि सीएएन बस कम्युनिकेशन सिस्टमसाठी फर्मवेअर डिझाइन आणि विकसित करा. सी/सी++ आणि रिअल-टाइम ओएसमधील मजबूत अनुभव आवश्यक.",
      },
      {
        title: "मेकॅनिकल डिझाईन अभियंता - ड्राइव्हट्रेन",
        dept: "अभियांत्रिकी",
        location: "ठाणे, महाराष्ट्र",
        type: "पूर्णवेळ (Full-time)",
        desc: "ट्रॅक्टर ड्राइव्हट्रेन, गिअरबॉक्सेस आणि इम्प्लीमेंट कपलिंग सिस्टमच्या मेकॅनिकल डिझाइनचे नेतृत्व करा. सॉलिडवर्क्स आणि प्रत्यक्ष फॅब्रिकेशन अनुभवास प्राधान्य.",
      },
      {
        title: "कृषी क्षेत्र अभियंता",
        dept: "संचालन",
        location: "अखिल भारतीय (प्रवास)",
        type: "पूर्णवेळ (Full-time)",
        desc: "ऑटोनेक्स्ट ट्रॅक्टर तैनात करण्यासाठी, फील्ड कामगिरीचा डेटा गोळा करण्यासाठी आणि भारतभरात तांत्रिक सहाय्य प्रदान करण्यासाठी थेट शेतकरी आणि कृषी-औद्योगिक ग्राहकांसोबत काम करा.",
      },
      {
        title: "व्यवसाय विकास व्यवस्थापक - कृषी क्षेत्र",
        dept: "विक्रय",
        location: "पुणे / नासिक",
        type: "पूर्णवेळ (Full-time)",
        desc: "मोठ्या शेती, साखर कारखाने आणि कृषी-औद्योगिक ग्राहकांशी संबंध निर्माण करा आणि व्यवस्थापित करा. ट्रॅक्टर विक्री, लीझिंग भागीदारी आणि सरकारी निविदा चालवा.",
      },
      {
        title: "आयओटी आणि टेलिमॅटिक्स अभियंता",
        dept: "अभियांत्रिकी",
        location: "ठाणे, महाराष्ट्र",
        type: "पूर्णवेळ (Full-time)",
        desc: "ऑटोनेक्स्ट फ्लीट टेलिमॅटिक्स प्लॅटफॉर्म विकसित करा — जीपीएस ट्रॅकिंग, रिमोट डायग्नोस्टिक्स, ओटीएस अपडेट्स आणि फील्ड सेन्सर्सपासून क्लाउड डॅशबोर्ड्सपर्यंत डेटा पाइपलाइन.",
      },
      {
        title: "विपणन आणि सामग्री रणनीतीकार",
        dept: "विपणन",
        location: "मुंबई / रिमोट",
        type: "पूर्णवेळ (Full-time)",
        desc: "ऑटोनेक्स्टची डिजिटल उपस्थिती नियंत्रित करा — कंटेंट मार्केटिंग, सोशल media, केस स्टडीज आणि एसईओ. कृषी-तंत्र किंवा शाश्वतता क्षेत्रातील अनुभव फायदेशीर ठरेल.",
      },
    ]
  },
  contributionPage: {
    metaTitle: "पर्यावरण आणि ESG योगदान | AutoNxt इलेक्ट्रिक ट्रॅक्टर्स",
    metaDescription: "AutoNxt इलेक्ट्रिक ट्रॅक्टर्सचे ESG प्रभाव, कार्बन फूटप्रिंट घट आणि पर्यावरणीय योगदान जाणून घ्या.",
    texts: {
      contribBadge: "आमचे योगदान",
      heroTitlePre: "भारतासाठी ",
      heroTitleHighlight: "तयार.",
      heroTitlePost: " पर्यावरणासाठी समर्पित.",
      heroDesc: "ऑटोनेक्स्ट ही केवळ वाहन निर्माता कंपनी नाही. आपण स्वच्छ हवा, हरित शहरे आणि स्वतंत्र इलेक्ट्रिक भविष्यासाठी भारताची वचनबद्धता आहोत.",
      co2Label: "CO₂ बचत",
      treesLabel: "झाडांच्या समतुल्य",
      initiativesLabel: "उपक्रम",
      keyInitiatives: "प्रमुख उपक्रम",
      ourJourney: "आमचा प्रवास",
      joinMovement: "चळवळीत सामील व्हा",
      joinDesc: "भारताच्या स्वच्छ ऊर्जा परिवर्तनाला गती देण्यासाठी ऑटोनेक्स्टशी भागीदारी करा. एकत्रितपणे, आपण बदल घडवू या.",
      partnerBtn: "आमच्याशी भागीदारी करा",
    },
    impacts: [
      { value: "1,500+", label: "टन CO₂ ऑफसेट", desc: "ऑटोनेक्स्ट ईवींनी भारतीय रस्त्यांवर रोखलेले आयुष्यमान कार्बन उत्सर्जन." },
      { value: "270+", label: "वाहने विद्युतीकृत", desc: "पेट्रोल आणि डीजेल वाहनांची जागा स्वच्छ ऑटोनेक्स्ट इलेक्ट्रिक पर्यायांनी घेतली." },
      { value: "70,650+", label: "झाडांचे समतुल्य", desc: "प्रति वर्ष कार्बन शोषणात समतुल्य पर्यावरणीय फायदा." },
    ],
    initiatives: [
      {
        title: "प्रकल्प स्वच्छ गती",
        desc: "१५ राज्य सरकारांच्या भागीदारीत २०२८ पर्यंत ५०,००० सार्वजनिक वाहतूक वाहनांचे विद्युतीकरण करण्याचा आमचा प्रमुख उपक्रम.",
        badge: "सक्रिय (Active)",
      },
      {
        title: "फेम इंडिया भागीदारी",
        desc: "भारताच्या फेम II योजनेशी सुसंगत, नगरपालिका, वाहतूकदार आणि वैयक्तिक ग्राहकांना अनुदानित ईव्ही उपाय प्रदान करणे.",
        badge: "शासन समर्थित",
      },
      {
        title: "आत्मनिर्भर गतिशीलता",
        desc: "१००% स्वदेशी बनावटीचे डिझाईन आणि उत्पादन — मोटर्सपासून बॅटरी व्यवस्थापन प्रणालीपर्यंत — भारतात ५,०००+ हून अधिक कुशल नोकऱ्या निर्माण करणे.",
        badge: "मेक इन इंडिया",
      },
    ],
    stats: [
      { label: "वाचवलेले खर्च", value: "₹30Cr" },
      { label: "उद्योग", value: "8 विश्वासू" },
      { label: "उपक्रम", value: "3 सक्रिय" },
    ],
    timeline: [
      { year: "2019", event: "स्थापना — ऑटोनेक्स्ट ऑटोमेशन प्रा. लि. ची स्थापना पुणे, महाराष्ट्रात झाली। स्वच्छ विद्युत गतिशीलतेचा पाया घालण्यासाठी पहिली संशोधन व विकास (R&D) प्रयोगशाळा उभारण्यात आली।" },
      { year: "2020", event: "पहिला प्रोटोटाइप — पहिला ईवी प्रोटोटाइप यशस्वीरित्या पूर्ण करण्यात आला आणि चाचणी घेण्यात आली। सिडबीआयकडून बीज निधी सुरक्षित करण्यात आली, ज्यामुळे पुढील R&D शक्य झाले।" },
      { year: "2021", event: "प्रमाणपत्र व भागीदारी — फेम II प्रमाणपत्र (इलेक्ट्रिक वाहनांचे वेगवान अडॉप्शन व उत्पादन) मिळवण्यात आले। 3 राज्य सरकारांशी ईवी अडॉप्शन वाढवण्यासाठी भागीदारी करार स्वाक्षरित केले गेले।" },
      { year: "2022", event: "वाणिज्यिक उत्पादन — पूर्ण व्यापारिक प्रमाणावर उत्पादन सुरू झाले। फ्लीट ऑपरेटर्सना 500 वाहने पुरवठे करण्यात आली, ज्यामुळे वाणिज्यिक ईवी निर्मात्यात ऑटोनेक्स्टची सुरुवात झाली।" },
      { year: "2023", event: "वेगवान वाढ — सीरीज बी फंडिंग यशस्वीरित्या उभारण्यात आली। 12 शहरांमध्ये कार्याचा विस्तार करण्यात आला। रस्त्यावर 5,000+ वाहनांचा इतिहासातील टप्पा गाठला।" },
      { year: "2024", event: "उपलब्धी — सौर चार्जिंग नेटवर्क अधिकृतरित्या लॉन्च करण्यात आले। संरक्षण क्षेत्रातील करार स्वाक्षरित केला। ऑटोनेक्स्टने भारतभर 10,000+ तैनात वाहनांची एतिहासिक सीमा ओलांडली।" },
      { year: "2025+", event: "वैश्विक विस्तार — आंतरराष्ट्रीय विस्तार सुरू वैश्विक। सोलिड-स्टेट बॅटरी पायलट प्रकल्प सुरू वैश्विक, जो ऑटोनेक्स्टच्या स्वच्छ उर्जा प्रवासातील पुढील टप्पा दर्शवतो।" },
    ]
  },
  legalAppAffiliation: {
    bannerTitle: "AUTONXT-Attendance साठी अधिकृत पृष्ठ",
    bannerDesc:
      "हे पृष्ठ AutoNxt Automation Pvt. Ltd. द्वारे प्रकाशित आहे, जे Google Play वर autonxtdeveloper डेव्हलपर खात्याअंतर्गत AUTONXT-Attendance मोबाइल अॅपचे डेव्हलपर आहे.",
    appNameLabel: "अॅपचे नाव",
    appNameValue: "AUTONXT-Attendance",
    developerLabel: "डेव्हलपर",
    developerValue: "AutoNxt Automation Pvt. Ltd.",
    playDeveloperLabel: "Google Play डेव्हलपर",
    playDeveloperValue: "autonxtdeveloper",
    packageIdLabel: "पॅकेज ID",
    packageIdValue: "com.autonxt.attendance.app2",
    websiteLabel: "वेबसाइट",
    websiteValue: "autonxt.in",
  },
  privacyPage: {
    metaTitle: "गोपनीयता धोरण — AUTONXT-Attendance | AutoNxt",
    texts: {
      legalBadge: "कायदेशीर",
      policyTitle: "गोपनीयता धोरण — AUTONXT-Attendance",
      metaDescription:
        "AUTONXT-Attendance (com.autonxt.attendance.app2) गोपनीयता धोरण, AutoNxt Automation Pvt. Ltd. (autonxtdeveloper) द्वारे.",
      effectiveDate: "प्रभावी तारीख: 18 जून 2025 · ऑटोनेक्स्ट ऑटोमेशन प्रा. लि.",
      policyIntro: 'ऑटोनेक्स्ट ऑटोमेशन प्रा. लि. ("ऑटोनेक्स्ट", "आम्ही", "आमचे" किंवा "आपल्याला"), AUTONXT-Attendance मोबाइल अॅप (पॅकेज: com.autonxt.attendance.app2, Google Play डेव्हलपर: autonxtdeveloper) चे डेव्हलपर, आमच्या मोबाइल अॅप वापरकर्ते, वेबसाइट (autonxt.in) भेट देणारे आणि सेवा वापरणाऱ्यांच्या गोपनीयतेचे संरक्षण करण्यास वचनबद्ध आहोत.',
      backToHome: "मुखपृष्ठावर परत",
      accountDeletionLink: "खाते हटवण्याची विनंती करा",
      copyright: "© २०२५ ऑटोनेक्स्ट ऑटोमेशन प्रा. लि. सर्व हक्क राखीव.",
    },
    sections: [
      {
        title: "१. आम्ही गोळा करतो ती माहिती",
        body: `जेव्हा आपण ऑटोनेक्स्ट वेबसाइटला भेट देता, चौकशी सबमिट करता किंवा डेमो बुक करता, तेव्हा आम्ही खालील माहिती गोळा करू शकतो:\n• वैयक्तिक ओळख माहिती: नाव, ईमेल पत्ता, फोन नंबर आणि संस्थेचे नाव.\n• वापर डेटा: भेट दिलेली पृष्ठे, घालवलेला वेळ, ब्राउझर प्रकार आणि आयपी पत्ता विश्लेषणात्मक साधनांद्वारे स्वयक्षितपणे गोळा केला जातो.\n• संवाद रेकॉर्ड: आमच्या संपर्क किंवा बुकिंग फॉर्मद्वारे आपण सबमिट केलेले कोणतेही संदेश, प्रश्न किंवा अभिप्राय.\n\nआम्ही थेट पेमेंट कार्ड तपशील गोळा करत नाही; कोणतेही व्यवहार प्रमाणित पेमेंट गेटवेद्वारे गोळा आणि प्रक्रिया केले जातात.`,
      },
      {
        title: "२. आम्ही आपल्या माहितीचा वापर कसा करतो",
        body: `आम्ही गोळा केलेल्या माहितीचा वापर खालील उद्देशांसाठी करतो:\n• आपल्या चौकशीला प्रतिसाद देण्यासाठी आणि उत्पादनाची माहिती किंवा दरपत्रक प्रदान करण्यासाठी.\n• डेमो बुकिंग, टेस्ट-ड्राइव्ह विनंत्या आणि खरेदी आदेशांवर प्रक्रिया करण्यासाठी.\n• संबंधित उत्पादन अद्यतने, बातम्या आणि ऑफर पाठवण्यासाठी — केवळ आपण अशा संवादांसाठी संमती दिली असल्यास.\n• विश्लेषणात्मक माहितीद्वारे आमच्या वेबसाइटची कार्यक्षमता आणि सामग्री सुधारण्यासाठी.\n• माहिती तंत्रज्ञान अधिनियम, २००० सह लागू भारतीय कायद्यांतर्गत कायदेशीर दायित्वांचे पालन करण्यासाठी.`,
      },
      {
        title: "३. डेटा सामायिकरण आणि प्रकटीकरण",
        body: `ऑटोनेक्स्ट ऑटोमेशन प्रा. लि. आपला वैयक्तिक डेटा इतर कोणालाही विकत नाही, भाड्याने देत नाही किंवा व्यापार करत नाही. आम्ही खालील मर्यादित परिस्थितींमध्ये डेटा सामायिक करू शकतो:\n• अधिकृत सेवा भागीदारांसोबत (उदा. सीआरएम, ईमेल आणि क्लाउड होस्टिंग प्रदाता) जे गोपनीयता करारांतर्गत केवळ आमच्या वतीने डेटावर प्रक्रिया करतात.\n• कायदा किंवा न्यायालयाच्या आदेशानुसार आवश्यक असल्यास सरकारी संस्था किंवा नियामक संस्थांसोबत.\n• विलीनीकरण, संपादन किंवा मालमत्ता विक्रीच्या परिस्थितीत, वापरकर्त्यांना कोणत्याही हस्तांतरणापूर्वी सूचित केले जाईल.`,
      },
      {
        title: "४. डेटा धारणा (Data Retention)",
        body: `आम्ही आपला वैयक्तिक डेटा केवळ तो गोळा केलेल्या उद्देशासाठी आवश्यक असेपर्यंत या लागू कायद्यानुसार आवश्यक असेपर्यंत राखून ठेवतो. चौकशी रेकॉर्ड सहसा ३ वर्षांपर्यंत ठेवले जातात. आपण software-admin@autonxt.in वर आमच्याशी संपर्क साधून कोणत्याही वेळी आपला डेटा हटवण्याची विनंती करू शकता.`,
      },
      {
        title: "५. कुकीज आणि ट्रॅकिंग",
        body: `आमची वेबसाइट आपला ब्राउझिंग अनुभव सुधारण्यासाठी आणि विश्लेषणात्मक माहिती गोळा करण्यासाठी कुकीज आणि तत्सम ट्रॅकिंग तंत्रज्ञानाचा वापर करते. यामध्ये समाविष्ट आहे:\n• आवश्यक कुकीज: वेबसाइट योग्यरित्या कार्य करण्यासाठी आवश्यक.\n• विश्लेषणात्मक कुकीज: अभ्यागत साइटशी कसे संवाद साधतात हे समजून घेण्यास मदत करतात (उदा. Google Analytics).\n• मार्केटिंग कुकीज: संबंधित सामग्री पोहोचवण्यासाठी आणि मोहिमेची प्रभावीता मोजण्यासाठी वापरली जाते.\n\nआपण आपल्या ब्राउझर सेटिंग्जद्वारे कोणत्याही वेळी कुकीज अक्षम करू शकता; तथापि, काही वैशिष्ट्ये योग्यरित्या कार्य करू शकणार नाहीत.`,
      },
      {
        title: "६. डेटा सुरक्षा",
        body: `आम्ही आपल्या वैयक्तिक डेटाचे अनधिकृत प्रवेश, बदल, प्रकटीकरण किंवा नष्ट होण्यापासून संरक्षण करण्यासाठी योग्य तांत्रिक आणि संस्थात्मक उपाययोजना लागू करतो. आमची वेबसाइट सर्व डेटा प्रक्षेपणासाठी HTTPS एन्क्रिप्शन वापरते. या उपायांचा अवलंब करूनही, कोणतेही इंटरनेट प्रक्षेपण पूर्णपणे सुरक्षित नसते आणि आम्ही संपूर्ण सुरक्षेची हमी देऊ शकत नाही.`,
      },
      {
        title: "७. आपले अधिकार",
        body: `आपल्याला खालील अधिकार आहेत:\n• आमच्याकडे आपल्याबद्दल असलेल्या वैयक्तिक डेटाचा प्रवेश मिळवणे.\n• चुकीचा किंवा अपूर्ण डेटा दुरुस्त करण्याची विनंती करणे.\n• कायदेशीर धारणा दायित्वांच्या अधीन राहून, आपला वैयक्तिक डेटा हटवण्याची विनंती करणे.\n• कोणत्याही वेळी मार्केटिंग संवादांची संमती मागे घेणे.\n• संबंधित डेटा संरक्षण प्राधिकरणाकडे तक्रार नोंदवणे.\n\nयांपैकी कोणत्याही अधिकाराचा वापर करण्यासाठी, software-admin@autonxt.in वर आमच्याशी संपर्क साधा किंवा +९१ ९०६७४०४६०६ वर कॉल करा.`,
      },
      {
        title: "८. तृतीय-पक्ष लिंक्स",
        body: `आमच्या वेबसाइटवर LinkedIn, YouTube आणि इतर भागीदार प्लॅटफॉर्मसह तृतीय-पक्षाच्या वेबसाइट्सच्या लिंक्स असू शकतात. आम्ही या साइट्सच्या गोपनीयता पद्धतींसाठी जबाबदार नाही आणि आपल्याला त्यांच्या संबंधित गोपनीयता धोरणांचे पुनरावलोकन करण्याचे आवाहन करतो.`,
      },
      {
        title: "९. या धोरणातील बदल",
        body: `ऑटोनेक्स्ट ऑटोमेशन प्रा. लि. कोणत्याही वेळी या गोपनीयता धोरणात सुधारणा करण्याचा अधिकार राखून ठेवते. कोणतेही बदल सुधारित प्रभावी तारखेसह या पृष्ठावर प्रकाशित केले जातील. आम्ही आपल्याला वेळोवेळी या धोरणाचे पुनरावलोकन करण्यास सुचवतो.`,
      },
      {
        title: "१०. आमच्याशी संपर्क साधा",
        body: `या गोपनीयता धोरणाशी संबंधित कोणत्याही प्रश्नांसाठी किंवा विनंत्यांसाठी, कृपया येथे संपर्क साधा:\n\nऑटोनेक्स्ट ऑटोमेशन प्रा. लि.\n७०४ आणि ७०५, एम्फोटेक आयटी पार्क, रोड ८, वागले इस्टेट रोड,\nपडवाल नगर, ठाणे वेस्ट, ठाणे, महाराष्ट्र ४००६०४\nफोन: +९१ ९०६७४०४६०६\nईमेल: software-admin@autonxt.in`,
      },
    ]
  },
  termsPage: {
    metaTitle: "नियम आणि अटी | AutoNxt",
    metaDescription: "ऑटोनेक्स्ट ऑटोमेशन वापरण्याचे नियम आणि अटी.",
    texts: {
      legalBadge: "कायदेशीर",
      termsTitle: "नियम आणि अटी",
      effectiveDate: "प्रभावी तारीख: १ जानेवारी २०२५ · ऑटोनेक्स्ट ऑटोमेशन प्रा. लि.",
      termsIntro: "कृपया ऑटोनेक्स्ट वेबसाइट वापरण्यापूर्वी या नियम आणि अटी काळजीपूर्वक वाचा. या साइटवर प्रवेश करून, आपण हे मान्य करता की आपण या अटी वाचल्या, समजल्या आणि त्यांच्याशी बांधील राहण्यास सहमत आहात.",
      backToHome: "मुखपृष्ठावर परत",
      copyright: "© २०२५ ऑटोनेक्स्ट ऑटोमेशन प्रा. लि. सर्व हक्क राखीव.",
    },
    sections: [
      {
        title: "१. अटींची स्वीकृती",
        body: `ऑटोनेक्स्ट वेबसाइट (autonxt.in) आणि कोणत्याही संबंधित सेवांवर प्रवेश करून किंवा वापर करून, आपण या अटी व शर्तींनुसार बांधील राहण्यास सहमत आहात. आपण या अटींशी सहमत नसल्यास, आपण आमची वेबसाइट किंवा सेवा वापरू नये. या अटी ऑटोनेक्स्ट ऑटोमेशन प्रा. लि. च्या सर्व अभ्यागत, वापरकर्ते आणि ग्राहकांना लागू होतात.`,
      },
      {
        title: "२. ऑटोनेक्स्टबद्दल",
        body: `ऑटोनेक्स्ट ऑटोमेशन प्रा. लि. ही कंपनी अधिनियम, २०१३ अंतर्गत समाविष्ट कंपनी आहे, जिचे नोंदणीकृत कार्यालय येथे आहे:\n\n७०४ आणि ७०५, एम्फोटेक आयटी पार्क, रोड ८, वागले इस्टेट रोड,\nपडवाल नगर, ठाणे वेस्ट, ठाणे, महाराष्ट्र ४००६०४\nCIN: [U29301MH2016PTC XXXXXX]\nGSTIN: [27XXXXX]`,
      },
      {
        title: "३. वेबसाइटचा वापर",
        body: `आपण या वेबसाइटचा वापर केवळ कायदेशीर उद्देशांसाठी आणि इतरांचे अधिकार धोक्यात येणार नाहीत अशा पद्धतीने करण्यास सहमत आहात. आपण खालील गोष्टी करू नयेत:\n• लागू असलेल्या स्थानिक, राष्ट्रीय किंवा आंतरराष्ट्रीय कायदा किंवा नियमांचे उल्लंघन करणाऱ्या कोणत्याही मार्गाने साइटचा वापर करणे.\n• अवांछित जाहिरात साहित्य किंवा स्पॅम पाठवणे.\n• वेबसाइटच्या कोणत्याही भागावर किंवा त्याच्या संबंधित प्रणाल्यांवर अनधिकृत प्रवेश मिळवण्याचा प्रयत्न करणे.\n• आमच्या स्पष्ट लेखी संमतीशिवाय या वेबसाइटचा कोणताही भाग पुनरुत्पादित करणे, त्याची कॉपी करणे, किंवा पुन्हा विक्री करणे.\n\nया अटींचे उल्लंघन करणाऱ्या कोणत्याही वापरकर्त्यासाठी वेबसाइटचा प्रवेश निलंबित किंवा प्रतिबंधित करण्याचा अधिकार ऑटोनेक्स्ट राखून ठेवते.`,
      },
      {
        title: "४. उत्पादन माहिती आणि किंमत",
        body: `या वेबसाइटवर दाखवलेले सर्व उत्पादन तपशील, कामगिरीची आकडेवारी आणि किंमती केवळ सूचक आहेत आणि कोणत्याही सूचनेशिवाय बदलू शकतात. अंतिम किंमत, वितरणाची वेळ आणि वॉरंटी अटी ऑर्डरच्या वेळी लेखी स्वरूपात निश्चित केल्या जातील. ऑटोनेक्स्ट कोणत्याही वेळी कोणतेही उत्पादन, ऑफर किंवा तपशील मागे घेण्याचा किंवा सुधारण्याचा अधिकार राखून ठेवते.`,
      },
      {
        title: "५. डेमो बुकिंग आणि चौकशी",
        body: `या वेबसाइटद्वारे डेमो बुकिंग किंवा उत्पादन चौकशी सबमिट करणे हा बंधनकारक करार किंवा खरेदी आदेश ठरत नाही. सर्व बुकिंग उपलब्धतेवर आणि ऑटोनेक्स्ट प्रतिनिधीच्या पुष्टीकरणावर अवलंबून असतात. ऑटोनेक्स्ट आपल्या विवेकबुद्धीनुसार कोणतीही बुकिंग विनंती नाकारण्याचा अधिकार राखून ठेवते.`,
      },
      {
        title: "६. बौद्धिक संपदा",
        body: `या वेबसाइटवरील सर्व सामग्री — ज्यामध्ये मजकूर, चित्रे, ग्राफिक्स, लोगो, व्हिडिओ आणि सॉफ्टवेअर समाविष्ट आहे, परंतु तेवढ्यापुरतेच मर्यादित नाही — ऑटोनेक्स्ट ऑटोमेशन प्रा. लि. किंवा तिच्या परवानाधारकांची बौद्धिक संपदा आहे आणि लागू असलेल्या भारतीय आणि आंतरराष्ट्रीय बौद्धिक संपदा कायद्यांद्वारे संरक्षित आहे. आपण ऑटोनेक्स्टच्या लेखी परवानगीशिवाय कोणतीही सामग्री वापरू शकत नाही, पुनरुत्पादित करू शकत नाही या वितरित करू शकत नाही.`,
      },
      {
        title: "७. अस्वीकरण आणि दायित्वाची मर्यादा",
        body: `ही वेबसाइट आणि तिची सामग्री कोणत्याही वॉरंटीशिवाय \"जशी आहे तशी\" प्रदान केली जाते. ऑटोनेक्स्ट ही वेबसाइट त्रुटीमुक्त असेल, अविरत असेल किंवा व्हायरस किंवा इतर हानिकारक घटकांपासून मुक्त असेल याची कोणतीही हमी देत नाही.\n\nलागू कायद्यानुसार परवानगी असलेल्या कमाल मर्यादेपर्यंत, या वेबसाइटच्या किंवा आमच्या सेवांच्या वापरामुळे उद्भवणाऱ्या कोणत्याही अप्रत्यक्ष, अपघाती, विशेष किंवा दंडात्मक नुकसानीसाठी ऑटोनेक्स्ट जबाबदार असणार नाही.`,
      },
      {
        title: "८. तृतीय-पक्ष लिंक्स",
        body: `या वेबसाइटवर तृतीय पक्षांद्वारे संचालित बाह्य वेबसाइट्सच्या लिंक्स असू शकतात. या लिंक्स केवळ सोयीसाठी दिल्या आहेत. ऑटोनेक्स्ट कोणत्याही संबंधित तृतीय-पक्ष वेबसाइटच्या सामग्री किंवा पद्धतींसाठी जबाबदार नाही.`,
      },
      {
        title: "९. लागू कायदा आणि कार्यक्षेत्र",
        body: `या अटी व शर्ती भारताच्या कायद्यानुसार नियंत्रित आणि अर्थ लावल्या जातात. या अटींच्या संदर्भात उद्भवणारा कोणताही वाद ठाणे, महाराष्ट्र येथील न्यायालयांच्या अनन्य अधिकारक्षेत्राच्या अधीन असेल.`,
      },
      {
        title: "१०. दुरुस्त्या",
        body: `ऑटोनेक्स्ट कोणत्याही वेळी या अटी व शर्तींमध्ये बदल करण्याचा अधिकार राखून ठेवते. सुधारित अटी या पृष्ठावर नवीन प्रभावी तारखेसह पोस्ट केल्या जातील. बदलांनंतर वेबसाइटचा वापर सुरू ठेवल्यास आपण सुधारित अटी स्वीकारल्याचे मानले जाईल.`,
      },
      {
        title: "११. संपर्क",
        body: `या अटी व शर्तींविषयी कोणत्याही प्रश्नांसाठी येथे संपर्क साधा:\n\nऑटोनेक्स्ट ऑटोमेशन प्रा. लि.\n७०४ आणि ७०५, एम्फोटेक आयटी पार्क, रोड ८, वागले इस्टेट रोड,\nपडवाल नगर, ठाणे वेस्ट, ठाणे, महाराष्ट्र ४००६०४\nफोन: +९१ ९०६७४०४६०६\nईमेल: sales@autonxt.in`,
      },
    ]
  },
  accountDeletionPage: {
    metaTitle: "खाते आणि डेटा हटवणे — AUTONXT-Attendance | AutoNxt",
    texts: {
      legalBadge: "वापरकर्ता डेटा",
      pageTitle: "खाते आणि डेटा हटवणे — AUTONXT-Attendance",
      pageSubtitle: "आपले AUTONXT-Attendance अॅप खाते आणि संबंधित वैयक्तिक डेटा हटवण्याची विनंती करा.",
      metaDescription:
        "AUTONXT-Attendance (com.autonxt.attendance.app2) खाते हटवा. AutoNxt Automation Pvt. Ltd. (autonxtdeveloper) चे अधिकृत खाते हटवण्याचे पृष्ठ.",
      effectiveDate: "प्रभावी तारीख: 18 जून 2025 · ऑटोनेक्स्ट ऑटोमेशन प्रा. लि.",
      pageIntro:
        'ऑटोनेक्स्ट ऑटोमेशन प्रा. लि. ("ऑटोनेक्स्ट"), AUTONXT-Attendance मोबाइल अॅप (पॅकेज: com.autonxt.attendance.app2, Google Play डेव्हलपर: autonxtdeveloper) चे डेव्हलपर, हे पृष्ठ अॅप वापरकर्त्यांसाठी आहे जे त्यांचे खाते आणि संबंधित वैयक्तिक डेटा हटवू इच्छितात.',
      requestTitle: "AUTONXT-Attendance खाते हटवण्याची विनंती कशी करावी",
      requestButton: "हटवण्याची विनंती ईमेल करा",
      requestMailto:
        "mailto:software-admin@autonxt.in?subject=AUTONXT-Attendance%20-%20Account%20Deletion%20Request&body=Please%20delete%20my%20AUTONXT-Attendance%20app%20account%20and%20associated%20data.%0A%0AApp%3A%20AUTONXT-Attendance%20(com.autonxt.attendance.app2)%0ARegistered%20email%20/%20phone%3A%20%0AEmployee%20ID%20(if%20any)%3A%20%0AAccount%20username%20(if%20any)%3A%20%0AReason%20(optional)%3A%20",
      processingNote:
        "आम्ही सत्यापित हटवण्याच्या विनंत्या सामान्यतः 30 दिवसांच्या आत प्रक्रिया करतो. आपले खाते आणि पात्र डेटा हटवल्यानंतर आपल्याला पुष्टीकरण ईमेल मिळेल.",
      deletedTitle: "हटवला जाणारा डेटा",
      retainedTitle: "ठेवला जाऊ शकणारा डेटा",
      privacyLinkTitle: "गोपनीयता धोरण",
      privacyLinkDesc: "आम्ही डेटा कसा गोळा करतो आणि वापरतो याबद्दलचे संपूर्ण गोपनीयता धोरण वाचा.",
      privacyLinkButton: "गोपनीयता धोरण पहा",
      backToHome: "मुख्यपृष्ठावर परत जा",
      copyright: "© 2025 ऑटोनेक्स्ट ऑटोमेशन प्रा. लि. सर्व हक्क राखीव.",
    },
    steps: [
      "आपल्या AutoNxt अॅप खात्याशी जोडलेल्या ईमेल पत्त्यावरून software-admin@autonxt.in वर ईमेल पाठवा.",
      "विषय ओळ वापरा: AutoNxt App - Account Deletion Request.",
      "आपला नोंदणीकृत ईमेल पत्ता, फोन नंबर आणि खाते वापरकर्तानाव (लागू असल्यास) समाविष्ट करा जेणेकरून आम्ही आपली ओळख सत्यापित करू शकू.",
      "आमची टीम आपली विनंती सत्यापित करेल आणि आपल्या खात्यासह संबंधित वैयक्तिक डेटा हटवेल.",
      "हटवणे पूर्ण झाल्यावर आपल्याला पुष्टीकरण ईमेल मिळेल.",
    ],
    deletedItems: [
      "आपले अॅप खाते प्रोफाइल (नाव, ईमेल, फोन नंबर आणि लॉगिन क्रेडेन्शियल्स)",
      "वापरकर्ता प्राधान्ये आणि अॅप सेटिंग्ज",
      "आपल्या खात्याशी जोडलेली जतन केलेली बुकिंग, डेमो विनंत्या आणि चौकशी इतिहास",
      "अॅप सूचनांसाठी वापरलेले पुश नोटिफिकेशन टोकन आणि डिव्हाइस ओळखकर्ते",
      "आपल्या खात्याशी संबंधित चॅट किंवा समर्थन संभाषण इतिहास",
      "केवळ आपल्या वापरकर्ता प्रोफाइलशी जोडलेला फ्लीट किंवा ट्रॅक्टर मॉनिटरिंग डेटा (जिथे लागू)",
    ],
    retainedItems: [
      "कायदेशीर, कर किंवा लेखा अनुपालनासाठी आवश्यक असलेले व्यवहार, चलन किंवा वarranty रेकॉर्ड (लागू कायद्यानुसार, सामान्यतः 7 वर्षांपर्यंत)",
      "अनामित किंवा एकत्रित विश्लेषण डेटा जो आपल्याला वैयक्तिकरित्या ओळखू शकत नाही",
      "भारतीय कायदा किंवा वैध न्यायालय/नियामक आदेशाअंतर्गत ठेवणे कायदेशीररित्या आवश्यक असलेले रेकॉर्ड",
      "बॅकअप प्रती कायमस्वरूपी हटवण्यापूर्वी हटवण्यानंतर 90 दिवसांपर्यंत राहू शकतात",
    ],
    sections: [
      {
        title: "अॅपमध्ये हटवणे (उपलब्ध असल्यास)",
        body: "जर आपल्या AutoNxt अॅप आवृत्तीत इन-अॅप खाते हटवण्याचा पर्याय असेल, तर आपण आपले खाते येथूनही हटवू शकता:\n\nअॅप → प्रोफाइल / सेटिंग्ज → खाते → खाते हटवा\n\nजर हा पर्याय आपल्या अॅप आवृत्तीत दिसत नसेल, तर कृपया वर वर्णन केलेली ईमेल प्रक्रिया वापरा.",
      },
      {
        title: "ओळख सत्यापन",
        body: "आपल्या खात्याचे संरक्षण करण्यासाठी, हटवण्याची विनंती प्रक्रिया करण्यापूर्वी आम्ही नोंदणीकृत ईमेल पत्ता किंवा फोन नंबरच्या मालकीची पुष्टी करण्यास सांगू शकतो. आम्ही असत्यापित तृतीय-पक्ष विनंतीवर आधारित खाते हटवणार नाही.",
      },
      {
        title: "प्रक्रिया वेळापत्रक",
        body: "सत्यापित खाते हटवण्याच्या विनंत्या 30 दिवसांच्या आत प्रक्रिया केल्या जातात. या कालावधीत, आपले खाते त्वरित निष्क्रिय केले जाऊ शकते, परंतु सर्व बॅकअप आणि सिस्टममधून पूर्ण हटवण्यास 90 दिवस लागू शकतात.",
      },
      {
        title: "संपर्क",
        body: "खाते हटवण्याच्या विनंत्या किंवा आपल्या वैयक्तिक डेटाबद्दल प्रश्नांसाठी:\n\nऑटोनेक्स्ट ऑटोमेशन प्रा. लि.\n७०४ आणि ७०५, एम्फोटेक आयटी पार्क, रोड ८, वागले इस्टेट रोड,\nपडवाल नगर, ठाणे वेस्ट, ठाणे, महाराष्ट्र ४००६०४\nफोन: +९१ ९०६७४०४६०६\nईमेल: software-admin@autonxt.in",
      },
    ],
  },
  notFoundPage: {
    title: "404 पृष्ठ आढळले नाही",
    desc: "आपण राउटरमध्ये पृष्ठ जोडण्यास विसरलात का?",
  },
  attachmentDetailPage: {
    availableNow: "आता उपलब्ध आहे",
    productNotFound: "उत्पादन आढळले नाही",
    backToProducts: "उत्पादनांवर परत जा",
    interactiveModel: "परस्परसंवादी मॉडेल",
    preview3D: "3D पूर्वावलोकन",
    loadingModel: "3D मॉडेल लोड होत आहे...",
    specifications: "तपशील",
    technicalDetails: "तांत्रिक तपशील",
    whyChoose: "हे उत्पादन का निवडावे",
    features: "वैशिष्ट्ये",
    quoteBtn: "कोट विनंती करा",
    bookBtn: "डेमो बुक करा",
    stats: {
      support: "मदत",
      supportVal: "24/7",
      availability: "उपलब्धता",
      availabilityVal: "संपूर्ण भारत",
      response: "प्रतिसाद",
      responseVal: "< 24 तास"
    },
    attachments: {
      bucket: {
        name: "18 फूट ग्रेबर बकेट",
        type: "हेवी ड्युटी इम्प्लीमेंट",
        badge: "हेवी ड्युटी",
        tagline: "कोणत्याही भूभागासाठी कमाल खोदण्याची क्षमता",
        desc: "कार्यक्षम साहित्य हाताळणी आणि उत्खनन कामांसाठी डिझाइन केलेले हेवी-ड्यूटी 18 फूट ग्रॅबर बकेट अटॅचमेंट. कठीण बांधकाम आणि शेती वातावरणात जास्तीत जास्त टिकाऊपणा आणि कामगिरीसाठी उत्कृष्ट साहित्य आणि प्रगत अभियांत्रिकीसह निर्मित.",
        specs: {
          width: "18 फूट",
          capacity: "0.8m³",
          material: "हार्डॉक्स 450",
          weight: "480 किलो",
          power: "45 kW",
          battery: "50 kWh",
          runtime: "6-8 तास",
          charging: "4-5 तास",
          widthLabel: "रुंदी",
          capacityLabel: "क्षमता",
          materialLabel: "साहित्य",
          weightLabel: "वजन",
          powerLabel: "शक्ती",
          batteryLabel: "बॅटरी",
          runtimeLabel: "रन टाइम",
          chargingLabel: "चार्जिंग"
        },
        features: [
          { title: "हार्डॉक्स स्टील", desc: "कठीण वातावरणात दीर्घकालीन टिकाऊपणासाठी उत्कृष्ट झीज प्रतिरोध।" },
          { title: "युनिव्हर्सल हिच", desc: "सर्व ऑटोनेक्स्ट ट्रॅक्टर प्लॅटफॉर्मशी सुसंगत।" },
          { title: "क्विक रिलीज टीथ", desc: "सुलभ देखभालीसाठी बदलण्यायोग्य दात प्रणाली।" }
        ],
        highlights: [
          "हेवी ड्युटी डिझाइन",
          "शून्य उत्सर्जन सुसंगत",
          "3 पॉइंट हिच",
          "औद्योगिक दर्जाचे स्टील",
          "जलद देखभाल",
          "भारतासाठी निर्मित"
        ]
      },
      catcher: {
        name: "18 फूट कॅचर",
        type: "अचूक इम्प्लीमेंट",
        badge: "प्रिसिजन",
        tagline: "कार्यक्षम साहित्य संकलन आणि कापणी",
        desc: "कार्यक्षम साहित्य संकलन आणि हाताळणी कामांसाठी अचूकपणे डिझाइन केलेले 18 फूट कॅचर अटॅचमेंट. कृषी आणि औद्योगिक अनुप्रयोगांमध्ये चांगल्या कामगिरीसाठी प्रगत हायड्रॉलिक नियंत्रणे आणि टिकाऊ बांधकाम वैशिष्ट्ये. सुधारित अचूकता आणि विश्वासार्हतेसह कापणी, साहित्य वर्गीकरण आणि विशेष संकलन कार्यांसाठी आदर्श. कठीण वातावरणात सातत्यपूर्ण कामगिरी देण्यासाठी उत्कृष्ट साहित्य आणि अत्याधुनिक अभियांत्रिकीसह निर्मित.",
        specs: {
          width: "18 फूट",
          capacity: "0.75m³",
          material: "हार्डॉक्स 400",
          weight: "450 किलो",
          power: "40 kW",
          battery: "45 kWh",
          runtime: "5-7 तास",
          charging: "3-4 तास",
          widthLabel: "रुंदी",
          capacityLabel: "क्षमता",
          materialLabel: "साहित्य",
          weightLabel: "वजन",
          powerLabel: "शक्ती",
          batteryLabel: "बॅटरी",
          runtimeLabel: "रन टाइम",
          chargingLabel: "चार्जिंग"
        },
        features: [
          { title: "अचूक अभियांत्रिकी", desc: "अचूक साहित्य संकलनासाठी आणि किमान सांडण्यासाठी अनुकूलित डिझाइन।" },
          { title: "युनिव्हर्सल हिच", desc: "सर्व ऑटोनेक्स्ट ट्रॅक्टर प्लॅटफॉर्मशी सुसंगत।" },
          { title: "सुलभ देखभाल", desc: "त्वरित सर्व्हिसिंगसाठी सुलभ देखभाल डिझाइन।" }
        ],
        highlights: [
          "अचूक डिझाइन",
          "शून्य उत्सर्जन सुसंगत",
          "3 पॉइंट हिच",
          "अनुकूलित क्षमता",
          "सुलभ देखभाल",
          "भारतासाठी निर्मित"
        ]
      },
      loader: {
        name: "18 फूट लोडर बकेट",
        type: "मॅक्स लोड इम्प्लीमेंट",
        badge: "कमाल लोड",
        tagline: "लोडिंग आणि साहित्य वाहतुकीमध्ये कमाल कार्यक्षमता",
        desc: "लोडिंग आणि साहित्य वाहतूक कामांमध्ये कमाल कार्यक्षमतेसाठी डिझाइन केलेले हेवी-ड्यूटी 18 फूट लोडर बकेट. सर्वात कठीण बांधकाम, खाणकाम आणि शेतीची कामे हाताळण्यासाठी उत्कृष्ट शक्ती साहित्य आणि प्रगत हायड्रॉलिक प्रणालीसह निर्मित. सुधारित साहित्य धारणा आणि कार्यक्षम लोडिंग चक्रांसाठी अनुकूलित बकेट भूमिती वैशिष्ट्ये. सर्वोच्च कामगिरी आणि संचालन विश्वसनीयता राखून अत्यंत कठीण कार्य परिस्थितीचा सामना करण्यासाठी डिझाइन केलेले.",
        specs: {
          width: "18 फूट",
          capacity: "0.9m³",
          material: "हार्डॉक्स 500",
          weight: "520 किलो",
          power: "50 kW",
          battery: "55 kWh",
          runtime: "7-9 तास",
          charging: "4-6 तास",
          widthLabel: "रुंदी",
          capacityLabel: "क्षमता",
          materialLabel: "साहित्य",
          weightLabel: "वजन",
          powerLabel: "शक्ती",
          batteryLabel: "बॅटरी",
          runtimeLabel: "रन टाइम",
          chargingLabel: "चार्जिंग"
        },
        features: [
          { title: "कमाल क्षमता", desc: "हेवी ऑपरेशन्समध्ये जास्तीत जास्त भार क्षमता आणि टिकाऊपणासाठी डिझाइन केलेले।" },
          { title: "युनिव्हर्सल हिच", desc: "सर्व ऑटोनेक्स्ट ट्रॅक्टर प्लॅटफॉर्मशी सुसंगत।" },
          { title: "मजबूत रचना", desc: "कमाल लोड सुरक्षितपणे हाताळण्यासाठी अतिरिक्त मजबुतीकरण।" }
        ],
        highlights: [
          "कमाल क्षमता",
          "शून्य उत्सर्जन सुसंगत",
          "3 पॉइंट हिच",
          "मजबूत स्टील",
          "हेवी ड्युटी डिझाइन",
          "भारतासाठी निर्मित"
        ]
      }
    }
  },
  aboutPage: {
    aboutAutoNxt: "ऑटोनेक्स्टबद्दल",
    foundedLabel: "स्थापना",
    headquarteredLabel: "मुख्यालय",
    teamSizeLabel: "टीमचे संख्याबळ",
    foundedInMumbai: "मुंबईत स्थापना",
    connectLinkedIn: "लिंक्डइनवर संपर्क साधा",
    ourJourney: "आमचा प्रवास",
    fromConcept: "संकल्पनेपासून ते मार्केट लीडरपर्यंत.",
    team: [
      { name: "कौस्तुभ धोंडे", role: "मुख्य कार्यकारी अधिकारी", bio: "अभिनव इलेक्ट्रिक वाहन उपायांद्वारे शेतीमध्ये क्रांती घडवून आणण्याच्या ऑटोनेक्स्टच्या ध्येयाचे नेतृत्व करणारे दूरदर्शी नेते।" },

      { name: "पंकज गोयल", role: "सह-संस्थापक आणि सीओओ", bio: "दैनिक कामकाज आणि भागीदारीवर देखरेख ठेवून सुलभ अंमलबजावणी आणि शाश्वत विकास सुनिश्चित करणारे ऑपरेशनल रणनीतिकार।" },
      { name: "गौरव बोरकर", role: "चीफ फायनान्शियल ऑफिसर", bio: "आर्थिक रणनीती, निधी उभारणी आणि कॉर्पोरेट गव्हर्नन्सचे नेतृत्व करणारे अनुभवी वित्त तज्ज्ञ." },
      { name: "अमित कुमार शिवहरे", role: "प्रमुख – लेखा (Head – Accounts)", bio: "कॉर्पोरेट अकाउंटिंग, करप्रणाली, वैधानिक अनुपालन आणि आर्थिक अहवालांमध्ये 16+ वर्षांचा अनुभव असलेले ज्येष्ठ वित्त तज्ज्ञ." },
      { name: "हरी किशन", role: "प्लँट हेड", bio: "प्लँटच्या कामकाजावर देखरेख ठेवतात, उत्पादित प्रत्येक ट्रॅक्टरमध्ये गुणवत्ता आणि कार्यक्षमता सुनिश्चित करतात।" },

      { name: "सुदीप्तो देब", role: "लीड पॉवर ट्रेन इंजिनिअर", bio: "पॉवर इलेक्ट्रॉनिक्समधील तज्ज्ञ, आमच्या ट्रॅक्टर्सना चालना देणाऱ्या इलेक्ट्रिक सिस्टीमचे डिझाइन आणि ऑप्टिमायझेशन करण्यासाठी जबाबदार।" },

      { name: "वंसी अटलुरी", role: "मुख्य यांत्रिक डिझाइन अभियंता", bio: "यांत्रिक डिझाइन संशोधक, विविध शेती गरजांसाठी मजबूत आणि कार्यक्षम ट्रॅक्टर रचनांचे डिझाइन करतात।" },

      { name: "डॉ. धर्मतेजा अडापा", role: "मुख्य रोबोटिक्स अभियंता", bio: "अचूक आणि कार्यक्षम ट्रॅक्टर कामगिरीसाठी स्मार्ट तंत्रज्ञान समाकलित करण्यावर लक्ष केंद्रित करणारे ऑटोमेशन तज्ज्ञ।" },

      { name: "तेजेश मदिरेड्डी", role: "मुख्य एम्बेडेड अभियंता", bio: "विश्वासार्ह आणि कार्यक्षम हार्डवेअर-सॉफ्टवेअर एकीकरण सुनिश्चित करत, एम्बेडेड सिस्टीमच्या विकासाचे नेतृत्व करतात।" },

      { name: "अस्वंथ मुलुपुरी", role: "रोबोटिक्स आणि ऑटोमेशन अभियंता", bio: "ऑटोमेशन तज्ज्ञ, स्वायत्त ट्रॅक्टर ऑपरेशनसाठी प्रगत नियंत्रण प्रणाल्या विकसित करतात।" },

      { name: "अजिंक्य डेलवी", role: "पॉवर ट्रेन अभियंता", bio: "पॉवर ट्रेन सिस्टीमवर काम करतात, कार्यक्षमता आणि कामगिरीचे ऑप्टिमायझेशन करतात।" },

      { name: "खुशप्रीत सिंग", role: "चाचणी आणि प्रमाणीकरण अभियंता", bio: "अतिशय कठोर चाचणी आणि प्रमाणीकरणासाठी जबाबदार, आमच्या उत्पादनांच्या विश्वासार्हतेची आणि सुरक्षेची हमी देतात।" },

      { name: "स्वप्नेश जहागीरदार", role: "व्यवसाय विकास व्यवस्थापक", bio: "कंपनीच्या विस्ताराला गती देण्यासाठी नवीन संधी ओळखणे आणि व्यावसायिक संबंध दृढ करण्यावर लक्ष केंद्रित करतात।" }
    ],
    advisors: [
      { name: "आयव्ही-राव", role: "वरिष्ठ सल्लागार", bio: "एकत्रितपणे, आम्ही अर्थपूर्ण डिझाइन आणि दीर्घकालीन प्रासंगिकतेद्वारे चांगल्या भविष्यासाठी स्वतःला आव्हान देतो।" },
      { name: "आशीष मेहता", role: "आर्थिक सल्लागार", bio: "समकालीन डिझाइन आणि दर्जेदार उत्पादने अशी आहेत ज्यांचा फायदा सर्वांना झाला पाहिजे — हेच आमच्या कामाचे उद्दिष्ट आहे।" },
      { name: "Swadeep Pillarisetti", role: "स्ट्रॅटेजी कन्सल्टंट", bio: "आमचे कलेक्शन सतत विकसित होणारे परंतु नेहमीच प्रासंगिक आहे. आमचे उद्दिष्ट आपल्याला हवी असलेली डिझाइन दाखवण्यास प्रेरित करणे आहे।" }
    ],
    journey: [
      { year: "2016", title: "स्थापना", desc: "इलेक्ट्रिक आणि स्वायत्त ट्रॅक्टर्सद्वारे कृषी आणि औद्योगिक कार्यात क्रांती घडवण्याच्या उद्दिष्टाने कौस्तुभ धोंडे यांनी मुंबईमध्ये ऑटोनेक्स्ट ऑटोमेशन प्रा. लि. ची स्थापना केली।" },
      { year: "2018–19", title: "संशोधन आणि सुरुवातीचे प्रोटोटाइप", desc: "हाय-टॉर्क इलेक्ट्रिक पॉवरट्रेन्स आणि इंटेलिजेंट कंट्रोल सिस्टीमवर व्यापक आर अँड डी. ऑटोनेक्स्टने डिझेल ट्रॅक्टरला इलेक्ट्रिक तंत्रज्ञानाने यशस्वीरित्या बदलून सुरुवातीचे प्रोटोटाइप तयार केले।" },
      { year: "2020–21", title: "नवनिर्मिती आणि विकास", desc: "अधिक स्मार्ट वाहन नियंत्रण प्रणाली आणि आयओटी-आधारित देखरेखीसह प्रगत प्रोटोटाइप. इंजिनिअरिंग टीमचा विस्तार केला आणि घटक विकासासाठी भागीदारी मजबूत केली।" },
      { year: "2022–23", title: "प्रमाणीकरण आणि चाचण्या", desc: "इलेक्ट्रिक ट्रॅक्टर्सची कामगिरी आणि सुरक्षेची कठोर चाचणी घेण्यात आली. iCAT (इंटरनॅशनल सेंटर फॉर ऑटोमोटिव्ह टेक्नॉलॉजी) कडून २० एचपी, ३५ एचपी आणि ४५ एचपी मॉडेल्ससाठी यशस्वीरित्या प्रमाणपत्रे प्राप्त केली।" },
      { year: "2024", title: "व्यावसायिक लाँच", desc: "ऑटोनेक्स्टने अधिकितपणे ठाणे, महाराष्ट्र येथे X45H2 लाँच केला. पहिले युनिट जयवंत शुगर्स लि. ला सुपूर्द केले गेले — ज्याने भारताच्या कृषी-ईव्ही परिसंस्थेमध्ये ऑटोनेक्स्टला अग्रेसर म्हणून स्थापित केले।" },
      { year: "2025+", title: "विकास आणि विस्तार", desc: "कृषी आणि औद्योगिक क्षेत्रात उत्पादन क्षमता आणि ग्राहक आधार वाढवणे. स्वायत्त ड्रायव्हिंग, स्मार्ट कनेक्टिव्हिटी आणि पुढच्या पिढीच्या बॅटरी सिस्टीम विकसित करणे।" }
    ],
    process: [
      { step: "01", title: "निश्चित करणे", desc: "इलेक्ट्रिक सेल्फ-ड्रायव्हिंग ट्रॅक्टर्ससाठीच्या गरजा निश्चित करणे — शेतातील निरीक्षणे आणि इंजिनिअरिंग मर्यादा एकत्रित करणे।" },
      { step: "02", title: "डिजाइन", desc: "3D मॉडेल्स आणि आकृत्या तयार करणे, मोटर, बॅटरी आणि सेन्सर्स सारखे योग्य घटक निवडणे आणि स्वायत्त ड्रायव्हिंग सिस्टीम डिझाइन करणे।" },
      { step: "03", title: "विकास", desc: "चेसिस, मोटर, बॅटरी, सेन्सर्स आणि स्वायत्त ड्रायव्हिंग सिस्टीमसह प्रत्यक्ष भौतिक घटकांची निर्मिती करणे।" },
      { step: "04", title: "चाचणी", desc: "भारतातील विविध भूभाग, हवामान आणि ड्रायव्हिंग परिस्थितीमध्ये कामगिरीची कठोर चाचणी घेणे।" },
      { step: "05", title: "सुधारणा", desc: "चाचणी निकालांवरून आवश्यकतेनुसार घटकांचे समायोजन करणे, सॉफ्टवेअर अल्गोरिदम सुधारणे आणि युझर इंटरफेस अधिक चांगला करणे।" },
      { step: "06", title: "उत्पादन", desc: "उत्पादन प्रक्रिया सेट करणे, घटक मिळवणे आणि मोठ्या प्रमाणावर वितरणाचे जाळे तयार करणे।" }
    ],
    values: [
      { title: "ग्राहक प्रथम", desc: "आम्ही आमच्या ग्राहकांच्या गरजा आणि समाधानाला इतर सर्व गोष्टींपेक्षा जास्त महत्त्व देतो।" },
      { title: "नवनिर्मिती", desc: "इलेक्ट्रिक वाहन तंत्रज्ञानातील नवनवीन प्रयोग सातत्याने पुढे नेणे।" },
      { title: "उत्कृष्टता", desc: "सर्वोच्च दर्जाची उत्पादने आणि सेवा प्रदान करण्यासाठी कटिबद्ध।" },
      { title: "शाश्वतता (सस्टेनेबिलिटी)", desc: "कृषी क्षेत्रासाठी अधिक हरित आणि पर्यावरणपूरक भविष्य घडवण्यासाठी समर्पित।" }
    ]
  },
  galleryPage: {
    galleryPhotos: "छायाचित्रे",
    galleryVideos: "व्हिडिओ",
    galleryEvents: "कार्यक्रम",
    eventHandoverTitle: "अधिकृत सरकारी हस्तांतरण सोहळा",
    eventHandoverDesc: "२९ जून, २०२५ — ऑटोनेक्स्टने सरकारी अधिकारी, पोलीस प्रतिनिधी आणि प्रसारमाध्यमांच्या उपस्थितीत एका अधिकृत सोहळ्यात X45H2 इलेक्ट्रिक ट्रॅक्टर सुपूर्द केला. भारताच्या सार्वजनिक संस्थांची सेवा करण्याच्या ऑटोनेक्स्टच्या प्रवासातील एक ऐतिहासिक क्षण.",
    photos: [
      { alt: "व्यावसायिक वितरणासाठी तयार असलेल्या ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर्सची पहिली खेप", label: "पहिल्या खेपेचे प्रेषण (डिस्पॅच)", tag: "शेतात" },
      { alt: "वितरणासाठी वाहतूक ट्रकवर लोड केलेले ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर्स", label: "वितरणासाठी लोड केलेले ट्रॅक्टर्स", tag: "शेतात" },
      { alt: "वाहतुकीसाठी तयार ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर्सची खेप", label: "वाहतुकीसाठी खेप", tag: "शेतात" },
      { alt: "नाशिकमधील कृषीथॉन २०२३ प्रदर्शनात प्रदर्शित ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर", label: "कृषीथॉन २०२३ — नाशिक शोकेस", tag: "शेतात" },
      { alt: "कृषीथॉन २०२३ मध्ये ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टर लोडरचे प्रात्यक्षिक", label: "कृषीथॉन २०२३ — लोडर प्रात्यक्षिक", tag: "शेतात" },
      { alt: "कमर्शियल ट्रेलरसह ऑटोनेक्स्ट X45H2", label: "X45H2 — व्यावसायिक वाहतूक", tag: "औद्योगिक" }
    ],
    events: [
      { alt: "अधिकारी आणि माध्यमांसह ऑटोनेक्स्ट X45H2 लाँच सोहळा", label: "अधिकृत लाँच संबोधन — २९ जून, २०२५", tag: "कार्यक्रम" },
      { alt: "एमओयू स्वाक्षरी सोहळा — ऑटोनेक्स्ट ट्रॅक्टर हस्तांतरण", label: "हस्तांतरण सोहळा आणि सामंजस्य करारावर स्वाक्षरी", tag: "कार्यक्रम" },
      { alt: "अधिकारी ऑटोनेक्स्ट X45H2 इलेक्ट्रिक ट्रॅक्टरला आशीर्वाद देताना", label: "X45H2 उद्घाटन सोहळा", tag: "कार्यक्रम" },
      { alt: "ऑटोनेक्स्ट X45H2 भोवती जमलेले मान्यवर आणि टीम", label: "X45H2 — अधिकृत आशीर्वाद", tag: "कार्यक्रम" },
      { alt: "सोहळ्यादरम्यान पाहुण्यांनी वेढलेला ऑटोनेक्स्ट X45H2 ट्रॅक्टर", label: "X45H2 — फ्लॅग-ऑफ सोहळा", tag: "कार्यक्रम" },
      { alt: "तिरंगी फुग्यांची कमान आणि कार्यक्रमात X45H2 चे प्रदर्शन", label: "तिरंगा लाँच स्टेज — २९ जून, २०२५", tag: "कार्यक्रम" },
      { alt: "लाँच कार्यक्रमात ऑटोनेक्स्ट X45H2 इलेक्ट्रिक ट्रॅक्टरचा क्लोज-अप", label: "ऑटोनेक्स्ट X45H2 — जवळून", tag: "उत्पादन" }
    ],
    videos: [
      { title: "ऑटोनेक्स्ट X45H2 इलेक्ट्रिक ट्रॅक्टर — उत्पादन वर्णन (इंग्रजीत)", desc: "ऑटोनेक्स्टच्या फ्लॅगशिप 45HP इलेक्ट्रिक ट्रॅक्टरचे संपूर्ण वर्णन — X45H2 — ज्यामध्ये तपशील, वैशिष्ट्ये आणि क्षमतांचा समावेश आहे." },
      { title: "X45H2 — मुसळधार पावसात आणि पूरग्रस्त शेतात रोटाव्हेटर पडलिंग", desc: "मुसळधार पावसाच्या हंगामात आणि पूर्णपणे पूर आलेल्या शेतात X45H2 ला रोटाव्हेटर पडलिंग करताना पहा." },
      { title: "महाराष्ट्रातील पहिला इलेक्ट्रिक ट्रॅक्टर जयवंत शुगर मिलला प्रदान", desc: "जयवंत शुगर मिल, कराड, सातारा येथे पहिल्या ऑटोनेक्स्ट इलेक्ट्रिक ट्रॅक्टरचे ऐतिहासिक हस्तांतरण — भारतीय कृषी-ईव्हीसाठी एक मैलाचा दगड." },
      { title: "ऑटोनेक्स्ट 45HP इलेक्ट्रिक ट्रॅक्टर — पूर्ण पॉवर डेमो", desc: "विविध शेती कामांमध्ये X45H2 ला आपल्या संपूर्ण टॉर्क आणि कामगिरीचे प्रदर्शन करताना पहा." },
      { title: "X45H2 — वाहतूक, टिलर, रीपर आणि वॉटर जेट वॉश", desc: "वाहतूक, नांगरणी, कापणी आणि संपूर्ण वॉटर जेट वॉश करणाऱ्या X45H2 चे व्यापक क्षेत्र प्रदर्शन." },
      { title: "ऑटोनेक्स्ट X45H2 इलेक्ट्रिक ट्रॅक्टर — उत्पादन वर्णन (मराठीत)", desc: "मराठीत ऑटोनेक्स्ट X45H2 इलेक्ट्रिक ट्रॅक्टरचे संपूर्ण उत्पादन वर्णन — भारतीय शेतकऱ्यांसाठी." }
    ]
  },
  blogPage: {
    postsLabel: "लेख",
    postsValue: "20+",
    authorsLabel: "लेखक",
    authorsValue: "6",
    topicsLabel: "विषय",
    posts: [
      {
        tag: "तंत्रज्ञान",
        title: "भारतीय शेतीत क्रांती: ऑटोनेक्स्टचे इलेक्ट्रिक ट्रॅक्टर शेतकऱ्यांसाठी बुद्धिमत्ता, शाश्वतता आणि नफा आणत आहेत",
        author: "द इंडिया वायर नेटवर्क",
        date: "ऑगस्ट 2025",
        readTime: "4 मिनिटे वाचा",
        image: "/images/x45h2Image2.webp",
        summary: "ऑटोनेक्स्ट ऑटोमेशनचे संस्थापक आणि सीईओ कौस्तुभ धोंडे आणि सह-संस्थापक आणि सीओओ पंकज गोयल यांच्या विशेष मुलाखतीत, त्यांची कंपनी भारतातील इलेक्ट्रिक ट्रॅक्टर क्रांतीचे नेतृत्व कसे करत आहे हे जाणून घ्या — डिझेलवरील अवलंबित्व कमी करण्यापासून स्मार्ट ऑपरेशन्ससाठी AI, IoT आणि टेलिमॅटिक्स समाकलित करण्यापर्यंत.",
        externalUrl: "https://theindiawire.com/india/revolutionizing-indian-agriculture-autonxts-electric-tractors-bring-intelligence-sustainability-and-profitability-to-farmers/",
        featured: true
      },
      {
        tag: "स्वायत्त तंत्रज्ञान",
        title: "भारताचा पहिला सेल्फ-ड्रायव्हिंग ट्रॅक्टर तयार करणे",
        author: "इनसाइडर्स टॉक",
        date: "डिसेंबर 2024",
        readTime: "6 मिनिटे वाचा",
        image: "/images/videos/driverless-tractor-thumbnail.webp",
        summary: "ऑटोनेक्स्ट स्वायत्त शेती तंत्रज्ञान विकसित करण्यात आघाडीवर आहे, भारताचा पहिला सेल्फ-ड्रायव्हिंग ट्रॅक्टर तयार करत आहे. हा विकास शेतकऱ्यांना वाढीव कार्यक्षमता, कमी कामगार खर्च आणि शेती कार्यांमध्ये सुधारित अचूकता प्रदान करतो.",
        externalUrl: "https://insiderstalk.in/building-indias-first-ever-self-driving-tractor/",
        featured: false
      },
      {
        tag: "भविष्यातील तंत्रज्ञान",
        title: "शेतीचे भविष्य: भारताचा पहिला सेल्फ-ड्रायव्हिंग ट्रॅक्टर",
        author: "ट्रॅक्टर जंक्शन",
        date: "नोव्हेंबर 2024",
        readTime: "8 मिनिटे वाचा",
        image: "/images/blog/future-of-farming.webp",
        summary: "ऑटोनेक्स्ट ऑटोमेशन भारताच्या पहिल्या स्वायत्त इलेक्ट्रिक ट्रॅक्टरसह शेतीच्या भविष्याकडे वाटचाल करत आहे, शाश्वत शेतीसह अत्याधुनिक तंत्रज्ञानाची सांगड घालत आहे.",
        externalUrl: "https://www.tractorjunction.com/tractor-news/future-of-farming-india-first-self-driving-tractor/",
        featured: false
      },
      {
        tag: "कृषी तंत्रज्ञान",
        title: "ऑटोनेक्स्ट ट्रॅक्टर: इलेक्ट्रिक आणि स्वायत्त तंत्रज्ञानासह कृषी क्षेत्रात क्रांती",
        author: "ट्रॅक्टर गुरु",
        date: "ऑक्टोबर 2024",
        readTime: "9 मिनिटे वाचा",
        image: "/images/blog/autonxt-tractor-revolutionizing-agriculture.webp",
        summary: "ऑटोनेक्स्टच्या नाविन्यपूर्ण ट्रॅक्टर सोल्यूशन्सचे सर्वसमावेशक कव्हरेज — इलेक्ट्रिक ट्रॅक्टर, स्वायत्त ड्रायव्हिंग क्षमता आणि स्मार्ट फार्मिंग सोल्यूशन्स जे भारतात आणि त्यापलीकडे आधुनिक कृषीच्या विकसित गरजा पूर्ण करतात.",
        externalUrl: "https://tractorguru.in/blog/category/autonxt-tractor/",
        featured: false
      },
      {
        tag: "कंपनी प्रोफाइल",
        title: "ऑटोनेक्स्ट ऑटोमेशन: इलेक्ट्रिक आणि स्वायत्त कृषी उपायांचे नेतृत्व",
        author: "ट्रॅक्सन रिसर्च टीम",
        date: "सप्टेंबर 2024",
        readTime: "7 मिनिटे वाचा",
        image: "/images/blog/game-changing-electric-tractor.webp",
        summary: "ऑटोनेक्स्ट ऑटोमेशनच्या नाविन्यपूर्ण दृष्टिकोनाचे तपशीलवार कंपनी प्रोफाइल आणि विश्लेषण. ऑटोनेक्स्टने स्वतःला कृषी नवोपक्रमात आघाडीवर स्थापित केले आहे.",
        externalUrl: "https://tracxn.com/d/companies/autonxt-automation/__ZSsZ4cr50wm63YgF4zOMI1CcYVW2V43yS-5Lojtdze0",
        featured: false
      },
      {
        tag: "कंपनी प्रोफाइल",
        title: "कौस्तुभ धोंडे: ऑटोनेक्स्ट ऑटोमेशनची कहाणी, इलेक्ट्रिक आणि स्वायत्त कृषी उपायांचे नेतृत्व",
        author: "शुगरमिंट",
        date: "मे 2024",
        readTime: "5 मिनिटे वाचा",
        image: "/images/blog/kaustubh-dhonde-story.webp",
        summary: "ऑटोनेक्स्ट ऑटोमेशनचे संस्थापक आणि मुख्य कार्यकारी अधिकारी (CEO) कौस्तुभ धोंडे यांच्यासोबतची एक प्रेरणादायी मुलाखत, ज्यामध्ये त्यांनी त्यांच्या वैयक्तिक प्रेरणा, भारतात ईव्ही ब्रँड सुरू करण्याची आव्हाने आणि देशातील पहिल्या स्वायत्त इलेक्ट्रिक ट्रॅक्टरच्या विकासाविषयी सांगितले आहे.",
        externalUrl: "https://sugermint.com/kaustubh-dhonde/",
        featured: false
      },
      {
        tag: "उद्योग बातम्या",
        title: "ऑटोनेक्स्ट ऑटोमेशन इलेक्ट्रिक - सेल्फ ड्रायव्हिंग ट्रॅक्टर लाँच करण्यासाठी सज्ज",
        author: "BW ऑनलाइन ब्युरो",
        date: "ऑगस्ट २०२२",
        readTime: "३ मिनिटे वाचन",
        image: "/images/blog/autonxt-bw-autoworld.webp",
        summary: "इलेक्ट्रिक ट्रॅक्टर स्टार्टअप ऑटोनेक्स्ट ऑटोमेशन बाजारात आपले २०HP, ३५HP आणि ४५HP इलेक्ट्रिक ट्रॅक्टर व्हेरियंट लाँच करण्यासाठी सज्ज आहे, ज्यामध्ये हाय-टॉर्क इलेक्ट्रिक पॉवरट्रेन आणि स्वायत्त ड्रायव्हिंग वैशिष्ट्ये समाविष्ट आहेत.",
        externalUrl: "https://bwautoworld.com/article/autonxt-automation-to-launch-an-electric-self-driving-tractor-442543",
        featured: false
      }
    ]
  },
  evBlogPage: {
    articlesLabel: "लेख",
    articlesValue: "७ तांत्रिक मार्गदर्शक",
    topicsLabel: "मुख्य फोकस",
    topicsValue: "५ श्रेणी",
    avgReadLabel: "सरासरी वाचन",
    avgReadValue: "६ मिनिटे",
    categories: ["All", "Battery Tech", "Policy & Incentives", "Market Trends", "Future Tech"],
    articles: [
      {
        cat: "शाश्वतता",
        title: "हरित वाढीच्या भारताच्या प्रयत्नांमध्ये इको-फ्रेंडली ट्रॅक्टरचा उदय",
        date: "जानेवारी 2025",
        readTime: "6 मिनिटे",
        image: "/images/blog/future-of-farming.webp",
        summary: "इको-फ्रेंडली इलेक्ट्रिक ट्रॅक्टर्सच्या उदयामुळे भारत आपल्या कृषी क्षेत्रात महत्त्वपूर्ण परिवर्तन पाहत आहे, जे देशाच्या महत्त्वाकांक्षी हरित वाढीच्या उपक्रमांशी जुळत आहे.",
        externalUrl: "https://www.theautomonitor.com/the-rise-of-eco-friendly-tractors-in-indias-push-for-green-growth/",
        featured: true
      },
      {
        cat: "नाविन्यपूर्ण",
        title: "इलेक्ट्रिक ट्रॅक्टर तंत्रज्ञानासह शाश्वतता आणि उत्पादकता जोडणे",
        date: "नोव्हेंबर 2025",
        readTime: "7 मिनिटे",
        image: "/images/blog/bridging-sustainability.webp",
        summary: "इलेक्ट्रिक ट्रॅक्टर तंत्रज्ञान वाढीव उत्पादकतेसह पर्यावरणीय शाश्वततेची सांगड घालून शेतीमध्ये क्रांती घडवून आणत आहे, ज्यामुळे शेतकऱ्यांना अधिक कार्यक्षम आणि किफायतशीर शेतीचा मार्ग उपलब्ध होत आहे.",
        externalUrl: "https://emobilityplus.com/2025/11/17/opinion-bridging-sustainability-and-productivity-with-electric-tractor-technology/",
        featured: true
      },
      {
        cat: "क्रांती",
        title: "इलेक्ट्रिक ट्रॅक्टर भारतीय शेतीत शाश्वत क्रांतीला कशी शक्ती देत आहेत",
        date: "जानेवारी 2025",
        readTime: "5 मिनिटे",
        image: "/images/blog/sustainable-revolution.webp",
        summary: "इलेक्ट्रिक ट्रॅक्टर संपूर्ण भारतात एक शाश्वत कृषी क्रांती घडवून आणत आहेत, पारंपारिक डिझेल मशीनरीला स्वच्छ आणि किफायतशीर पर्याय देत आहेत.",
        externalUrl: "https://republicnewsindia.com/how-electric-tractors-are-powering-a-sustainable-revolution-in-indian-agriculture/",
        featured: false
      },
      {
        cat: "भविष्यातील तंत्रज्ञान",
        title: "धुराशिवाय शेती: इलेक्ट्रिक ट्रॅक्टर भारतीय शेतीचे भविष्य का आहेत",
        date: "फेब्रुवारी 2025",
        readTime: "8 मिनिटे",
        image: "/images/blog/farming-without-fumes.webp",
        summary: "इलेक्ट्रिक ट्रॅक्टर भारतीय शेतीच्या भविष्याचे प्रतिनिधित्व करतात, हानिकारक उत्सर्जन दूर करून उत्कृष्ट कामगिरी प्रदान करतात आणि देशभरातील शेतकऱ्यांसाठी खर्च कमी करतात.",
        externalUrl: "https://www.thehindubusinessline.com/economy/agri-business/farming-without-fumes-why-electric-tractors-are-the-future-of-indian-agriculture/article70202273.ece",
        featured: false
      },
      {
        cat: "बॅटरी तंत्रज्ञान",
        title: "इलेक्ट्रिक ट्रॅक्टर्सच्या पुढील पिढीला सक्षम करणारे नाविन्यपूर्ण बॅटरी तंत्रज्ञान",
        date: "जुलै 2024",
        readTime: "6 मिनिटे",
        image: "/images/blog/innovative-battery-tech.webp",
        summary: "नाविन्यपूर्ण बॅटरी तंत्रज्ञान, मॉड्यूलर सिस्टीम आणि हायड्रोजन इंधन पेशींद्वारे शाश्वत शेतीमध्ये इलेक्ट्रिक ट्रॅक्टर कसे महत्त्वाचे उपाय म्हणून उदयास येत आहेत याचा शोध घेते.",
        externalUrl: "https://www.theautomonitor.com/innovative-battery-technologies-powering-the-next-generation-of-electric-tractors/",
        featured: false
      },
      {
        cat: "धोरणे आणि प्रोत्साहन",
        title: "सरकारी धोरणे आणि सबसिडी इलेक्ट्रिक ट्रॅक्टरच्या अवलंबनाला गती देत आहेत",
        date: "जानेवारी 2025",
        readTime: "6 मिनिटे",
        image: "/images/blog/government-policies.webp",
        summary: "कृषी क्षेत्राला इको-फ्रेंडली इलेक्ट्रिक ट्रॅक्टरकडे नेण्यासाठी सहायक सरकारी धोरणे, सबसिडी आणि जागतिक शाश्वतता उपक्रम कसे कारणीभूत ठरत आहेत यावर चर्चा करते.",
        externalUrl: "https://www.theautomonitor.com/government-policies-and-subsidies-driving-the-adoption-of-electric-tractors/",
        featured: false
      },
      {
        cat: "बाजार प्रवाह",
        title: "2026 हे वर्ष भारतीय शेतीतील इलेक्ट्रिक ट्रॅक्टरसाठी टर्निंग पॉइंट का ठरू शकते",
        date: "जानेवारी 2026",
        readTime: "4 मिनिटे",
        image: "/images/blog/why-2026-turning-point.webp",
        summary: "आगामी धोरणात्मक बदल, बॅटरी खर्चातील कपात आणि तांत्रिक सुधारणांमुळे 2026 हे वर्ष भारतात इलेक्ट्रिक ट्रॅक्टरच्या वापरासाठी मैलाचा दगड कसे ठरू शकते यावर प्रकाश टाकते.",
        externalUrl: "https://www.theautomonitor.com/why-2026-could-be-the-turning-point-for-electric-tractors-in-indian-agriculture/",
        featured: false
      }
    ],
    authorRoleLabel: "Publication",
    stats: [
      { value: "38%", label: "बाजार CAGR 2024–27" },
      { value: "₹4,000 कोटी", label: "2027 पर्यंत भारतातील EV ट्रॅक्टर TAM" },
      { value: "70%", label: "डीझेलच्या तुलनेत कमी धावण्याचा खर्च" },
      { value: "0", label: "थेट CO₂ उत्सर्जन" }
    ]
  },
  newsPage: {
    storiesLabel: "कथा",
    storiesValue: "50+",
    coverageLabel: "प्रकाशक",
    coverageValue: "National",
    milestonesLabel: "श्रेणी",
    milestonesValue: "6 Key",
    readMore: "Read More",
    news: [
      {
        date: "6/18/2026",
        tag: "पुरस्कार",
        title: "ऑटोनेक्स्ट ऑटोमेशनने ITOTY 2026 मध्ये पहिला 'इलेक्ट्रिक ट्रॅक्टर ऑफ द ईयर' पुरस्कार जिंकला",
        summary: "ऑटोनेक्स्ट ऑटोमेशनने इंडियन ट्रॅक्टर ऑफ द ईयर (ITOTY) Awards 2026 मध्ये पहिला 'इलेक्ट्रिक ट्रॅक्टर ऑफ द ईयर' पुरस्कार जिंकला आहे, जो भारताच्या इलेक्ट्रिक कृषी यंत्रसामग्री उद्योगासाठी एक ऐतिहासिक मैलाचा दगड आहे.",
        author: "ऑटोनेक्स्ट टीम",
        readTime: "3 मिनिटे वाचा",
        image: "/images/linkedin/linkedin-post-1.webp",
        externalUrl: "https://www.linkedin.com/posts/autonxt-automation_autonxt-itoty2026-electrictractoroftheyear-activity-7473003691902451712-w4BZ?utm_source=share&utm_medium=member_desktop&rcm=ACoAACrujPEBnx6l4DUGYojLDsLzMTTIYS7FTxk"
      },
      {
        date: "11/10/2024",
        tag: "आयोजन",
        title: "ऑटोनेक्स्टने दिल्ली ईव्ही रॅली 'BREATHE' मध्ये इलेक्ट्रिक ट्रॅक्टरचे प्रदर्शन केले, मंत्री मनोहर लाल खट्टर यांनी कौतुक केले",
        summary: "ऑटोनेक्स्ट दिल्लीमधील CESL च्या नामांकित EV रॅली, BREATHE मध्ये सहभागी होणारा एकमेव इलेक्ट्रिक ट्रॅक्टर होता. माननीय वीज मंत्री श्री मनोहर लाल खट्टर यांनी आमच्या ट्रॅक्टरची सवारी केली आणि त्याच्या सुरळीत कामगिरीचे कौतुक केले.",
        author: "ऑटोनेक्स्ट टीम",
        readTime: "3 मिनिटे वाचा",
        image: "/images/events/event-1.webp",
        externalUrl: "https://www.linkedin.com/company/autonxt-automation"
      },
      {
        date: "4/10/2024",
        tag: "उत्पादन लाँच",
        title: "ऑटोनेक्स्ट ऑटोमेशन भारताचा पहिला सेल्फ-ड्रायव्हिंग इलेक्ट्रिक ट्रॅक्टर लाँच करणार",
        summary: "ऑटोनेक्स्टने भारताच्या पहिल्या सेल्फ-ड्रायव्हिंग इलेक्ट्रिक ट्रॅक्टरचे अनावरण केले आहे, जे नाविन्यपूर्ण तंत्रज्ञानासह शाश्वत शेती आणि व्यावसायिक क्षेत्रांना पुढे नेणार आहे.",
        author: "रॉबिन कुमार अत्री",
        readTime: "5 मिनिटे वाचा",
        externalUrl: "https://www.cmv360.com/tractors/news/autonxt-automation-launching-india-first-self-driving-electric-tractor"
      },
      {
        date: "4/9/2024",
        tag: "फंडिंग",
        title: "ऑटोनेक्स्ट ऑटोमेशनने सामा (Saama) च्या नेतृत्वात प्री-सिरीज ए फंडिंग मिळवले",
        summary: "ऑटोनेक्स्ट विविध क्षेत्रातील व्यावसायिक वापरासाठी डिझाइन केलेल्या सेल्फ-ड्रायव्हिंग पर्यायांसह भारताचा पहिला इलेक्ट्रिक ट्रॅक्टर लाँच करणार आहे.",
        author: "ऑनलाइन ब्युरो",
        readTime: "2 मिनिटे वाचा",
        externalUrl: "https://auto.economictimes.indiatimes.com/news/automotive/autonxt-automation-secures-pre-series-a-funding-led-by-saama/109165048"
      },
      {
        date: "4/10/2024",
        tag: "फंडिंग",
        title: "ऑटोनेक्स्ट भारताचा पहिला सेल्फ-ड्रायव्हिंग इलेक्ट्रिक ट्रॅक्टर सादर करणार, प्री-सीरीज ए फंडिंग मिळवले",
        summary: "ऑटोनेक्स्ट ऑटोमेशनने सामा (Saama) च्या नेतृत्वाखालील आपला प्री-सिरीज ए फंडिंग राऊंड यशस्वीरित्या पूर्ण केला आहे.",
        author: "सुनेहा मिश्रा",
        readTime: "4 मिनिटे वाचा",
        externalUrl: "https://tractornews.in/news/autonxt-automation-to-introduce-india-s-first-self-driving-electric-tractor-secures-pre-series-a-funding/"
      },
      {
        date: "4/9/2024",
        tag: "फंडिंग",
        title: "ऑटोनेक्स्ट ऑटोमेशनने सामाकडून प्री-सिरीज ए फंडिंग मिळवले",
        summary: "ऑटोनेक्स्ट ऑटोमेशन व्यावसायिक अनुप्रयोगांसाठी भारताच्या पहिल्या सेल्फ-ड्रायव्हिंग इलेक्ट्रिक ट्रॅक्टरच्या विकासाला गती देण्यासाठी महत्त्वपूर्ण निधी मिळवते.",
        author: "ट्रॅक्टर जंक्शन",
        readTime: "3 मिनिटे वाचा",
        externalUrl: "https://www.tractorjunction.com/tractor-news/autonxt-automation-secures-pre-series-a-funding-from-saama/"
      },
      {
        date: "4/9/2024",
        tag: "फंडिंग",
        title: "ऑटोनेक्स्टने इलेक्ट्रिक ऑटोनॉमस ट्रॅक्टर डेव्हलपमेंटसाठी फंडिंग सुरक्षित केले",
        summary: "ऑटोनेक्स्ट ऑटोमेशनने व्यावसायिक आणि कृषी अनुप्रयोगांसाठी इलेक्ट्रिक स्वायत्त ट्रॅक्टरच्या विकासाला पुढे नेण्यासाठी निधी मिळवला आहे.",
        author: "मेरकॉम इंडिया",
        readTime: "3 मिनिटे वाचा",
        externalUrl: "https://www.mercomindia.com/autonxt-pre-series-a-funding"
      },
      {
        date: "4/10/2024",
        tag: "नाविन्यपूर्ण",
        title: "ऑटोनेक्स्टचा गेम-चेंजिंग इलेक्ट्रिक ट्रॅक्टर शेती आणि उद्योगात बदल घडवणार",
        summary: "सेल्फ-ड्रायव्हिंग क्षमता असलेला ऑटोनेक्स्टचा क्रांतिकारी इलेक्ट्रिक ट्रॅक्टर भारतभरातील शेती आणि औद्योगिक ऑपरेशन्समध्ये बदल घडवून आणणार आहे.",
        author: "अहमदाबाद मिरर",
        readTime: "4 मिनिटे वाचा",
        externalUrl: "https://www.ahmedabadmirror.com/autonxts-game-changing-electric-tractor-set-to-transform-farming-and-industry-in-india/81891265.html"
      },
      {
        date: "4/10/2024",
        tag: "शेती",
        title: "भारतीय शेतीत क्रांती: ऑटोनेक्स्टचे इलेक्ट्रिक ट्रॅक्टर बुद्धिमत्ता आणि शाश्वतता आणत आहेत",
        summary: "ऑटोनेक्स्टचे इलेक्ट्रिक ट्रॅक्टर देशभरातील शेतकऱ्यांसाठी बुद्धिमत्ता, शाश्वतता आणि नफा आणून भारतीय शेतीत क्रांती घडवत आहेत.",
        author: "फर्स्ट इंडिया",
        readTime: "5 मिनिटे वाचा",
        externalUrl: "https://firstindia.co.in/news/press-releases/revolutionizing-indian-agriculture-autonxts-electric-tractors-bring-intelligence-sustainability-and-profitability-to-farmers"
      },
      {
        date: "4/9/2024",
        tag: "फंडिंग",
        title: "ऑटोनेक्स्ट ऑटोमेशनने इलेक्ट्रिक ऑटोनॉमस ट्रॅक्टरसाठी प्री-सिरीज ए फंडिंग मिळवले",
        summary: "ऑटोनेक्स्ट ऑटोमेशन शाश्वत शेती उपायांसाठी इलेक्ट्रिक स्वायत्त ट्रॅक्टरच्या विकासाला पुढे नेण्यासाठी निधी सुरक्षित करते.",
        author: "ईव्ही रिपोर्टर",
        readTime: "3 मिनिटे वाचा",
        externalUrl: "https://evreporter.com/autonxt-automation-secures-pre-series-a-funding-for-electric-autonomous-tractor/"
      },
      {
        date: "5/15/2024",
        tag: "मील का पत्थर",
        title: "ऑटोनेक्स्ट ऑटोमेशनच्या इलेक्ट्रिक ट्रॅक्टरची ठाणे आरटीओमध्ये अधिकृत नोंदणी",
        summary: "ऑटोनेक्स्ट ऑटोमेशनने एक ऐतिहासिक टप्पा गाठला कारण त्यांच्या 45HP इलेक्ट्रिक ट्रॅक्टरला ठाणे, महाराष्ट्र येथे पहिली अधिकृत व्यावसायिक आरटीओ (RTO) वाहन नोंदणी मिळाली.",
        author: "शुगरमिंट",
        readTime: "3 मिनिटे वाचा",
        externalUrl: "https://sugermint.com/autonxt-automation-electric-tractor/"
      }
    ]
  },

  dealerPage: {
    metaTitle: "सेल पार्टनर आणि डीलर नेटवर्क | AutoNxt इलेक्ट्रिक ट्रॅक्टर्स",
    metaDescription: "सर्व महाराष्ट्र आणि भारतात AutoNxt अधिकृत सेल पार्टनर्स, डीलर प्रोफाइल आणि त्यांची कामे पहा.",
    badge: "सेल पार्टनर कार्यक्रम",
    title: "AutoNxt चे अधिकृत",
    titleHighlight: "सेल पार्टनर व्हा",
    subtitle: "भारताच्या अग्रगण्य इलेक्ट्रिक ट्रॅक्टर क्रांतीत सामील व्हा. आमचे देशव्यापी सेल पार्टनर नेटवर्क, डीलर प्रोफाइल आणि उपलब्धी पहा.",
    mapSection: {
      badge: "देशव्यापी नेटवर्क",
      title: "संपूर्ण भारतात AutoNxt चे डीलरशिप जाळे",
      subtitle: "आमचे अधिकृत सेल पार्टनर, अनुभव केंद्र आणि 3S सेवा केंद्र प्रमुख कृषी आणि औद्योगिक केंद्रांमध्ये कार्यरत आहेत.",
      stats: [
        { value: "25+", label: "सक्रिय डीलरशिप आऊटलेट्स" },
        { value: "15+", label: "समाविष्ट राज्ये" },
        { value: "100%", label: "3S सेवा पाठबळ" },
        { value: "500+", label: "चार्जिंग नेटवर्क पॉईंट्स" }
      ]
    },
    profilesSection: {
      badge: "डीलर नेटवर्क",
      title: "आमचे अधिकृत सेल पार्टनर्स आणि कामगिरी",
      subtitle: "भारतीय शेतात आणि उद्योगात इलेक्ट्रिक ट्रॅक्टर आणणारे आमचे विश्वासू डीलरशिप प्रोफाईल आणि त्यांची कामे पहा.",
      searchPlaceholder: "डीलरचे नाव, शहर, राज्य किंवा कामावरून शोधा...",
      filterAll: "सर्व राज्ये",
      contactDealer: "पार्टनरशी संपर्क साधा",
      viewWork: "कामगिरी पहा",
    },
    benefits: {
      title: "AutoNxt सोबत भागीदारी का करावी?",
      subtitle: "विशेष फायदे मिळवा आणि भारताच्या अग्रगण्य इलेक्ट्रिक ट्रॅक्टर ब्रँडसोबत वाढा.",
      items: [
        { title: "विशेष प्रादेशिक अधिकार", description: "ओव्हरलॅपिंग डीलरशिप नाहीत, तुमच्या भागात जास्तीत जास्त बाजार क्षमता सुनिश्चित करणारे समर्पित प्रादेशिक अधिकार." },
        { title: "प्रशिक्षण आणि प्रमाणन", description: "तुमच्या टीमला तज्ञ-स्तरीय ज्ञानाने सुसज्ज करण्यासाठी सर्वसमावेशक उत्पादन, विक्री आणि सेवा प्रशिक्षण." },
        { title: "मार्केटिंग सहाय्य", description: "लीड्स आणि ब्रँड दृश्यमानता वाढवण्यासाठी सह-ब्रँडेड मार्केटिंग साहित्य, डिजिटल मोहिमा आणि इव्हेंट सहाय्य." },
        { title: "स्पर्धात्मक मार्जिन", description: "आकर्षक डीलर मार्जिन आणि व्हॉल्यूम-आधारित प्रोत्साहन कार्यक्रम." }
      ]
    },
    form: {
      title: "सेल पार्टनर बनण्यासाठी अर्ज करा",
      subtitle: "खालील फॉर्म भरा आणि आमची टीम 24–48 तासांच्या आत तुमच्याशी संपर्क करेल.",
      name: "पूर्ण नाव",
      namePlaceholder: "तुमचे पूर्ण नाव प्रविष्ट करा",
      email: "ईमेल पत्ता",
      emailPlaceholder: "you@company.com",
      phone: "फोन नंबर",
      phonePlaceholder: "+91 98765 43210",
      company: "कंपनी / फर्मचे नाव",
      companyPlaceholder: "तुमचे व्यवसाय किंवा फर्मचे नाव",
      city: "शहर / जिल्हा",
      cityPlaceholder: "उदा. सातारा, नाशिक, लुधियाना",
      state: "राज्य",
      statePlaceholder: "तुमचे राज्य निवडा",
      experience: "सध्याचा व्यवसाय / डीलरशिप अनुभव",
      experiencePlaceholder: "उदा. ऑटो / कृषी मशिनरीमध्ये 5+ वर्षे",
      message: "तुम्हाला AutoNxt सेल पार्टनर का व्हायचे आहे?",
      messagePlaceholder: "तुमची आवड, शोरुम आणि इलेक्ट्रिक ट्रॅक्टर्सबद्दल माहिती द्या...",
      submit: "सेल पार्टनर अर्ज सबमिट करा",
      submitting: "सबमिट होत आहे...",
      successTitle: "अर्ज सबमिट झाला!",
      successMessage: "AutoNxt पार्टनर बनण्यात तुमच्या स्वारस्याबद्दल धन्यवाद. आमची टीम लवकरच तुमच्याशी संपर्क करेल.",
      errorMessage: "काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा.",
      submitAnother: "आणखी एक अर्ज सबमिट करा"
    },
    states: [
      "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
      "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
      "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
      "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
      "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
      "Uttar Pradesh", "Uttarakhand", "West Bengal",
      "Delhi", "Jammu & Kashmir", "Ladakh", "Puducherry", "Chandigarh"
    ],
    directory: {
      tag: "अधिकृत नेटवर्क",
      title: "अधिकृत डीलर आणि ठिकाणे",
      subtitle: "संपूर्ण भारतात ऑटोनेक्स्टच्या सत्यापित अधिकृत डीलरशिप केंद्रांचे, विक्री भागीदारांचे आणि सेवा केंद्रांचे जाळे शोधा.",
      searchPlaceholder: "डीलरचे नाव, शहर, ईमेल, मोबाईल किंवा पत्ता शोधा...",
      allStates: "सर्व राज्ये",
      dacNumber: "डीएसी क्रमांक",
      dealerName: "डीलरचे नाव",
      email: "डीलर ईमेल",
      mobile: "डीलर मोबाईल",
      gstNo: "डीलर जीएसटी क्रमांक",
      panNo: "डीलर पॅन",
      address: "पत्ता",
      noResults: "तुमच्या शोधाशी जुळणारा कोणताही अधिकृत डीलर आढळला नाही.",
      resetSearch: "फिल्टर रीसेट करा",
      dealers: [
        {
          id: "4",
          dealerName: "कंपेज ऑटोमेशन सिस्टम",
          address: "प्लॉट क्र. 20-21, सेक्टर 12, न्यू डीएलएफ इंडस्ट्रियल एरिया, हरियाणा, फरीदाबाद, 121003",
          state: "हरियाणा"
        },
        {
          id: "5",
          dealerName: "किसान कल्याण एंटरप्रायझेस",
          address: "शॉप 02, मोर हाऊस ग्राउंड फ्लोअर, कोर्ट एरिया, रेमंड समोर, बार्र्ह, पाटणा, बिहार, 803213",
          state: "बिहार"
        },
        {
          id: "6",
          dealerName: "एसएस कॉर्पोरेशन",
          address: "खतावणी क्र. 5152, खेवट क्र. 3262, एन, नमस्ते चौक, कर्नाळ, हरियाणा, 132001",
          state: "हरियाणा"
        },
        {
          id: "7",
          dealerName: "साई सीमा ऑटोमोटिव्ह",
          address: "गट क्र. 579/580 साई सीमा ऑटोमोटिव्ह, कोकणगाव निफाड, पिंपळगाव बसवंत, महाराष्ट्र, नाशिक, 422209",
          state: "महाराष्ट्र"
        }
      ]
    }
  },

  // Team Page
  teamPage: {
    metaTitle: "आमची टीम आणि नेतृत्व | AutoNxt इलेक्ट्रिक ट्रॅक्टर्स",
    metaDescription: "AutoNxt Automation मध्ये भारताचे पहिले इलेक्ट्रिक आणि स्वायत्त ट्रॅक्टर तंत्रज्ञान विकसित करणाऱ्या अभियंते, संशोधक आणि नेतृत्वाला भेटा.",
    badge: "आमचे नवसंशोधक",
    title: "भेटा AutoNxt च्या",
    titleHighlight: "निर्मात्यांना",
    subtitle: "दूरदृष्टी असलेले नेते, मेकॅनिकल इंजिनिअर्स, पॉवरट्रेन तज्ज्ञ, रोबोटिक्स तंत्रज्ञ आणि कृषी तंत्रज्ञांची एक बहुविद्याशाखीय टीम जी भारतीय शेती आणि उद्योगांचे विद्युतीकरण करत आहे.",
    stats: [
      { value: "150+", label: "उत्साही नवसंशोधक" },
      { value: "10+", label: "अभियांत्रिकी शाखा" },
      { value: "50+", label: "पेटंट्स आणि प्रमाणपत्रे" },
      { value: "100%", label: "स्वदेशी नवकल्पना" }
    ],
    categories: {
      all: "सर्व सदस्य",
      leadership: "नेतृत्व",
      finance: "वित्त आणि धोरण",
      sales: "सेल्स टीम",
      powertrain: "पॉवरट्रेन आणि बॅटरी",
      robotics: "रोबोटिक्स आणि सॉफ्टवेअर",
      manufacturing: "उत्पादन आणि प्रकल्प",
      advisors: "सल्लागार मंडळ"
    },
    leadershipTitle: "कार्यकारी नेतृत्व",
    leadershipSubtitle: "शाश्वत यांत्रिकीकरण आणि स्वायत्त भविष्यासाठी धाडसी दृष्टिकोनासह AutoNxt चे मार्गदर्शन.",
    teamTitle: "कोर अभियांत्रिकी आणि ऑपरेशन्स",
    teamSubtitle: "उच्च-टॉर्क इलेक्ट्रिक ट्रॅक्टर्सची रचना, निर्मिती आणि परिपूर्णता करणारी जागतिक दर्जाची प्रतिभा.",
    advisorsTitle: "स्ट्रॅटेजिक सल्लागार मंडळ",
    advisorsSubtitle: "उद्योग क्षेत्रातील दिग्गज जे AutoNxt ला जागतिक उत्कृष्टतेकडे नेण्यासाठी मार्गदर्शन करत आहेत.",
    connectLinkedIn: "लिंक्डइनवर कनेक्ट व्हा",
    connect: "कनेक्ट व्हा",
    ctaBadge: "AutoNxt मधील करिअर",
    ctaTitle: "इलेक्ट्रिक शेतीचे भविष्य घडवायचे आहे का?",
    ctaDesc: "संशोधक, विचारवंत आणि निर्मात्यांच्या वेगाने वाढणाऱ्या टीममध्ये सामील व्हा. अभियांत्रिकी, ऑपरेशन्स आणि सॉफ्टवेअरमधील संधी पहा.",
    ctaButton: "खुली पदे पहा",
    teamMembers: [
      {
        name: "कौस्तुभ धोंडे",
        role: "मुख्य कार्यकारी अधिकारी (CEO)",
        category: "leadership",
        bio: "अभिनव इलेक्ट्रिक वाहन तंत्रज्ञानाद्वारे शेतीमध्ये क्रांती घडवून आणण्याच्या AutoNxt च्या ध्येयाचे नेतृत्व करणारे दूरदर्शी नेते.",
        featured: true
      },
      {
        name: "पंकज गोयल",
        role: "सह-संस्थापक आणि सीओओ (COO)",
        category: "leadership",
        bio: "कंपनीच्या कार्यक्षम वाढीची खात्री देणारे रणनीतिकार, दैनंदिन कामकाज आणि भागीदारीचे व्यवस्थापन पाहतात.",
        featured: true
      },
      {
        name: "गौरव बोरकर",
        role: "चीफ फायनान्शियल ऑफिसर (CFO)",
        category: "finance",
        bio: "आर्थिक रणनीती, निधी उभारणी आणि कॉर्पोरेट गव्हर्नन्सचे नेतृत्व करणारे अनुभवी वित्त तज्ज्ञ.",
        featured: true
      },
      {
        name: "अमित कुमार शिवहरे",
        role: "प्रमुख – लेखा (Head – Accounts)",
        category: "finance",
        bio: "कॉर्पोरेट अकाउंटिंग, करप्रणाली, वैधानिक अनुपालन आणि आर्थिक अहवालांमध्ये 16+ वर्षांचा अनुभव असलेले ज्येष्ठ वित्त तज्ज्ञ."
      },
      {
        name: "हरी किशन",
        role: "प्लांट हेड",
        category: "manufacturing",
        bio: "प्रकल्प कामकाजाची देखरेख करतात, प्रत्येक उत्पादित ट्रॅक्टरमध्ये गुणवत्ता आणि कार्यक्षमता सुनिश्चित करतात."
      },
      {
        name: "सुदीप्तो देब",
        role: "लीड पॉवर ट्रेन इंजिनिअर",
        category: "powertrain",
        bio: "पॉवर इलेक्ट्रॉनिक्स तज्ज्ञ, आमच्या ट्रॅक्टर्सना ऊर्जा देणाऱ्या इलेक्ट्रिकल सिस्टिम्सची रचना आणि ऑप्टिमायझेशन करतात."
      },
      {
        name: "वामसी अट्लुरी",
        role: "लीड मेकॅनिकल डिझाइन इंजिनिअर",
        category: "powertrain",
        bio: "विविध कृषी गरजांसाठी मजबूत आणि कार्यक्षम ट्रॅक्टर स्ट्रक्चर्स तयार करणारे मेकॅनिकल डिझाइन संशोधक."
      },
      {
        name: "डॉ. धर्मतेजा अदापा",
        role: "लीड रोबोटिक्स इंजिनिअर",
        category: "robotics",
        bio: "ट्रॅक्टरच्या सुरळीत आणि विश्वासार्ह कामगिरीसाठी स्मार्ट तंत्रज्ञान समाविष्ट करणारे ऑटोमेशन तज्ज्ञ."
      },
      {
        name: "तेजेश मादिरेड्डी",
        role: "लीड एम्बेडेड इंजिनिअर",
        category: "robotics",
        bio: "विश्वासार्ह आणि कार्यक्षम हार्डवेअर-सॉफ्टवेअर इंटिग्रेशन सुनिश्चित करत एम्बेडेड सिस्टिम्स विकासाचे नेतृत्व करतात."
      },
      {
        name: "अश्वंथ मुलुपुरी",
        role: "रोबोटिक्स आणि ऑटोमेशन इंजिनिअर",
        category: "robotics",
        bio: "स्वायत्त ट्रॅक्टर चालवण्यासाठी प्रगत नियंत्रण प्रणाली विकसित करणारे ऑटोमेशन स्पेशालिस्ट."
      },
      {
        name: "अजिंक्य डेलवी",
        role: "पॉवर ट्रेन इंजिनिअर",
        category: "powertrain",
        bio: "पॉवर ट्रेन सिस्टिम्सवर काम करत कार्यक्षमता आणि ऊर्जा बचतीचे ऑप्टिमायझेशन करतात."
      },
      {
        name: "खुशप्रीत सिंग",
        role: "टेस्टिंग आणि व्हॅलिडेशन इंजिनिअर",
        category: "manufacturing",
        bio: "उत्पादनांची विश्वासार्हता आणि सुरक्षितता सुनिश्चित करण्यासाठी कठोर चाचण्या आणि प्रमाणीकरणाची जबाबदारी सांभाळतात."
      },
      {
        name: "स्वप्नेश जहागीरदार",
        role: "बिझनेस डेव्हलपमेंट मॅनेजर",
        category: "sales",
        bio: "कंपनीचा विस्तार गतिमान करण्यासाठी नवीन व्यावसायिक संधी शोधणे आणि संबंध वृद्धिंगत करणे यावर लक्ष केंद्रित."
      }
    ],
    advisorsList: [
      {
        name: "आयव्ही-राव",
        role: "ज्येष्ठ सल्लागार",
        bio: "मारुती सुझुकीचे माजी कार्यकारी सल्लागार आणि अभियांत्रिकी प्रमुख. ऑटोमोटिव्ह आर्किटेक्चर आणि सिस्टिम्स अभियांत्रिकीमध्ये AutoNxt ला मार्गदर्शन."
      },
      {
        name: "आशिष मेहता",
        role: "आर्थिक सल्लागार",
        bio: "भांडवल वाटप, व्हेंचर स्केल आणि शाश्वत व्यावसायिक विस्तारावर मार्गदर्शन करणारे अनुभवी वित्तीय रणनीतिकार."
      },
      {
        name: "स्वादीप पिल्लारीसेट्टी",
        role: "स्ट्रॅटेजी कन्सल्टंट",
        bio: "प्रॉडक्ट-मार्केट फिट, एंटरप्राइझ विक्री आणि उच्च-प्रभावी भागीदारींना गती देणारे जागतिक रणनीती तज्ज्ञ."
      }
    ]
  }
};
